(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("uK0kx", function(module, exports) {

var $38kyy = parcelRequire("38kyy");

var $2thha = parcelRequire("2thha");

var $05c67cf5129a5847$var$w = typeof window === 'undefined' ? (parcelRequire("foUwZ")) : window;
var $05c67cf5129a5847$var$document = $05c67cf5129a5847$var$w.document;
var $05c67cf5129a5847$var$Text = $05c67cf5129a5847$var$w.Text;
function $05c67cf5129a5847$var$context() {
    var cleanupFuncs = [];
    function h() {
        var args = [].slice.call(arguments), e = null;
        function item(l) {
            var r;
            function parseClass(string) {
                // Our minimal parser doesn’t understand escaping CSS special
                // characters like `#`. Don’t use them. More reading:
                // https://mathiasbynens.be/notes/css-escapes .
                var m = $38kyy(string, /([\.#]?[^\s#.]+)/);
                if (/^\.|#/.test(m[1])) e = $05c67cf5129a5847$var$document.createElement('div');
                $05c67cf5129a5847$var$forEach(m, function(v) {
                    var s = v.substring(1, v.length);
                    if (!v) return;
                    if (!e) e = $05c67cf5129a5847$var$document.createElement(v);
                    else if (v[0] === '.') $2thha(e).add(s);
                    else if (v[0] === '#') e.setAttribute('id', s);
                });
            }
            if (l == null) ;
            else if ('string' === typeof l) {
                if (!e) parseClass(l);
                else e.appendChild(r = $05c67cf5129a5847$var$document.createTextNode(l));
            } else if ('number' === typeof l || 'boolean' === typeof l || l instanceof Date || l instanceof RegExp) e.appendChild(r = $05c67cf5129a5847$var$document.createTextNode(l.toString()));
            else if ($05c67cf5129a5847$var$isArray(l)) $05c67cf5129a5847$var$forEach(l, item);
            else if ($05c67cf5129a5847$var$isNode(l)) e.appendChild(r = l);
            else if (l instanceof $05c67cf5129a5847$var$Text) e.appendChild(r = l);
            else if ('object' === typeof l) for(var k in l){
                if ('function' === typeof l[k]) {
                    if (/^on\w+/.test(k)) (function(k, l) {
                        if (e.addEventListener) {
                            e.addEventListener(k.substring(2), l[k], false);
                            cleanupFuncs.push(function() {
                                e.removeEventListener(k.substring(2), l[k], false);
                            });
                        } else {
                            e.attachEvent(k, l[k]);
                            cleanupFuncs.push(function() {
                                e.detachEvent(k, l[k]);
                            });
                        }
                    })(k, l);
                    else {
                        // observable
                        e[k] = l[k]();
                        cleanupFuncs.push(l[k](function(v) {
                            e[k] = v;
                        }));
                    }
                } else if (k === 'style') {
                    if ('string' === typeof l[k]) e.style.cssText = l[k];
                    else for(var s in l[k])(function(s, v) {
                        if ('function' === typeof v) {
                            // observable
                            e.style.setProperty(s, v());
                            cleanupFuncs.push(v(function(val) {
                                e.style.setProperty(s, val);
                            }));
                        } else var match = l[k][s].match(/(.*)\W+!important\W*$/);
                        if (match) e.style.setProperty(s, match[1], 'important');
                        else e.style.setProperty(s, l[k][s]);
                    })(s, l[k][s]);
                } else if (k === 'attrs') for(var v in l[k])e.setAttribute(v, l[k][v]);
                else if (k.substr(0, 5) === "data-") e.setAttribute(k, l[k]);
                else e[k] = l[k];
            }
            else if ('function' === typeof l) {
                //assume it's an observable!
                var v = l();
                e.appendChild(r = $05c67cf5129a5847$var$isNode(v) ? v : $05c67cf5129a5847$var$document.createTextNode(v));
                cleanupFuncs.push(l(function(v) {
                    if ($05c67cf5129a5847$var$isNode(v) && r.parentElement) r.parentElement.replaceChild(v, r), r = v;
                    else r.textContent = v;
                }));
            }
            return r;
        }
        while(args.length)item(args.shift());
        return e;
    }
    h.cleanup = function() {
        for(var i = 0; i < cleanupFuncs.length; i++)cleanupFuncs[i]();
        cleanupFuncs.length = 0;
    };
    return h;
}
var $05c67cf5129a5847$var$h = module.exports = $05c67cf5129a5847$var$context();
$05c67cf5129a5847$var$h.context = $05c67cf5129a5847$var$context;
function $05c67cf5129a5847$var$isNode(el) {
    return el && el.nodeName && el.nodeType;
}
function $05c67cf5129a5847$var$forEach(arr, fn) {
    if (arr.forEach) return arr.forEach(fn);
    for(var i = 0; i < arr.length; i++)fn(arr[i], i);
}
function $05c67cf5129a5847$var$isArray(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
}

});
parcelRegister("38kyy", function(module, exports) {
/*!
 * Cross-Browser Split 1.1.1
 * Copyright 2007-2012 Steven Levithan <stevenlevithan.com>
 * Available under the MIT License
 * ECMAScript compliant, uniform cross-browser split method
 */ /**
 * Splits a string into an array of strings using a regex or string separator. Matches of the
 * separator are not included in the result array. However, if `separator` is a regex that contains
 * capturing groups, backreferences are spliced into the result each time `separator` is matched.
 * Fixes browser bugs compared to the native `String.prototype.split` and can be used reliably
 * cross-browser.
 * @param {String} str String to split.
 * @param {RegExp|String} separator Regex or string to use for separating the string.
 * @param {Number} [limit] Maximum number of items to include in the result array.
 * @returns {Array} Array of substrings.
 * @example
 *
 * // Basic use
 * split('a b c d', ' ');
 * // -> ['a', 'b', 'c', 'd']
 *
 * // With limit
 * split('a b c d', ' ', 2);
 * // -> ['a', 'b']
 *
 * // Backreferences in result array
 * split('..word1 word2..', /([a-z]+)(\d+)/i);
 * // -> ['..', 'word', '1', ' ', 'word', '2', '..']
 */ module.exports = function split(undef) {
    var nativeSplit = String.prototype.split, compliantExecNpcg = /()??/.exec("")[1] === undef, // NPCG: nonparticipating capturing group
    self;
    self = function(str, separator, limit) {
        // If `separator` is not a regex, use `nativeSplit`
        if (Object.prototype.toString.call(separator) !== "[object RegExp]") return nativeSplit.call(str, separator, limit);
        var output = [], flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.extended ? "x" : "") + // Proposed for ES6
        (separator.sticky ? "y" : ""), // Firefox 3+
        lastLastIndex = 0, // Make `global` and avoid `lastIndex` issues by working with a copy
        separator = new RegExp(separator.source, flags + "g"), separator2, match, lastIndex, lastLength;
        str += ""; // Type-convert
        if (!compliantExecNpcg) // Doesn't need flags gy, but they don't hurt
        separator2 = new RegExp("^" + separator.source + "$(?!\\s)", flags);
        /* Values for `limit`, per the spec:
     * If undefined: 4294967295 // Math.pow(2, 32) - 1
     * If 0, Infinity, or NaN: 0
     * If positive number: limit = Math.floor(limit); if (limit > 4294967295) limit -= 4294967296;
     * If negative number: 4294967296 - Math.floor(Math.abs(limit))
     * If other: Type-convert, then use the above rules
     */ limit = limit === undef ? 4294967295 : limit >>> 0; // ToUint32(limit)
        while(match = separator.exec(str)){
            // `separator.lastIndex` is not reliable cross-browser
            lastIndex = match.index + match[0].length;
            if (lastIndex > lastLastIndex) {
                output.push(str.slice(lastLastIndex, match.index));
                // Fix browsers whose `exec` methods don't consistently return `undefined` for
                // nonparticipating capturing groups
                if (!compliantExecNpcg && match.length > 1) match[0].replace(separator2, function() {
                    for(var i = 1; i < arguments.length - 2; i++)if (arguments[i] === undef) match[i] = undef;
                });
                if (match.length > 1 && match.index < str.length) Array.prototype.push.apply(output, match.slice(1));
                lastLength = match[0].length;
                lastLastIndex = lastIndex;
                if (output.length >= limit) break;
            }
            if (separator.lastIndex === match.index) separator.lastIndex++; // Avoid an infinite loop
        }
        if (lastLastIndex === str.length) {
            if (lastLength || !separator.test("")) output.push("");
        } else output.push(str.slice(lastLastIndex));
        return output.length > limit ? output.slice(0, limit) : output;
    };
    return self;
}();

});

parcelRegister("2thha", function(module, exports) {
// contains, add, remove, toggle

var $73aJM = parcelRequire("73aJM");
module.exports = $1ccbb0db48077047$var$ClassList;
function $1ccbb0db48077047$var$ClassList(elem) {
    var cl = elem.classList;
    if (cl) return cl;
    var classList = {
        add: add,
        remove: remove,
        contains: contains,
        toggle: toggle,
        toString: $toString,
        length: 0,
        item: item
    };
    return classList;
    function add(token) {
        var list = getTokens();
        if ($73aJM(list, token) > -1) return;
        list.push(token);
        setTokens(list);
    }
    function remove(token) {
        var list = getTokens(), index = $73aJM(list, token);
        if (index === -1) return;
        list.splice(index, 1);
        setTokens(list);
    }
    function contains(token) {
        return $73aJM(getTokens(), token) > -1;
    }
    function toggle(token) {
        if (contains(token)) {
            remove(token);
            return false;
        } else {
            add(token);
            return true;
        }
    }
    function $toString() {
        return elem.className;
    }
    function item(index) {
        var tokens = getTokens();
        return tokens[index] || null;
    }
    function getTokens() {
        var className = elem.className;
        return $1ccbb0db48077047$var$filter(className.split(" "), $1ccbb0db48077047$var$isTruthy);
    }
    function setTokens(list) {
        var length = list.length;
        elem.className = list.join(" ");
        classList.length = length;
        for(var i = 0; i < list.length; i++)classList[i] = list[i];
        delete list[length];
    }
}
function $1ccbb0db48077047$var$filter(arr, fn) {
    var ret = [];
    for(var i = 0; i < arr.length; i++)if (fn(arr[i])) ret.push(arr[i]);
    return ret;
}
function $1ccbb0db48077047$var$isTruthy(value) {
    return !!value;
}

});
parcelRegister("73aJM", function(module, exports) {
var $52212469f058390b$var$indexOf = [].indexOf;
module.exports = function(arr, obj) {
    if ($52212469f058390b$var$indexOf) return arr.indexOf(obj);
    for(var i = 0; i < arr.length; ++i){
        if (arr[i] === obj) return i;
    }
    return -1;
};

});


parcelRegister("foUwZ", function(module, exports) {
"use strict";

});



var $uK0kx = parcelRequire("uK0kx");
var $aecf0f9332b42428$exports = {};
$aecf0f9332b42428$exports = [
    {
        "title": "Ki\u015Fisel Geli\u015Fim Programlar\u0131",
        "list": [
            {
                "title": "Beden Dili ve \u0130leti\u015Fimdeki Etkisi",
                "text": "Beden dili ile verilen mesajlar\u0131n kar\u015F\u0131 taraf \xfczerindeki etkisinin kat\u0131l\u0131mc\u0131lar taraf\u0131ndan anla\u015F\u0131lmas\u0131n\u0131n sa\u011Flanmas\u0131",
                "list": [
                    "\u0130nsan Hayat\u0131nda \u0130leti\u015Fimin \xd6nemi",
                    "Ki\u015Fileraras\u0131 \u0130li\u015Fkilerde \u0130leti\u015Fim Tarzlar\u0131m\u0131z",
                    "\u0130leti\u015Fimde \u0130lk G\xf6ze \xc7arpan D\u0131\u015F G\xf6r\xfcn\xfcm ve Beden Dili",
                    "G\xf6z Temas\u0131 Kuramasayd\u0131k Ne Yapard\u0131k?",
                    "Konu\u015Furken Nas\u0131l Bir Beden Dili Sergiliyoruz?",
                    "Hareketlerimizin Analizi",
                    "S\xf6zs\xfcz \u0130leti\u015Fim Becerilerini Geli\u015Ftirme"
                ]
            },
            {
                "title": "Bireysel Kalitemizi Geli\u015Ftirmek",
                "text": "\xc7evremizdeki de\u011Fi\u015Fim, bu de\u011Fi\u015Fimin i\u015F d\xfcnyas\u0131na ve bireylere yans\u0131mas\u0131 do\u011Frultusunda bireysel kalitemizi geli\u015Ftirmek i\xe7in etken olan insan, proses ve teknoloji gibi temel dinamiklerin \xf6nemi ve kaliteli i\u015F \xe7evresinin sa\u011Flanmas\u0131ndaki rol\xfc ile bu temel dinamiklerin birbiriyle etkile\u015Fimleri",
                "list": [
                    "Bireysel Liderlik",
                    "Ki\u015Fisel Hedefler Belirlemek",
                    "Ki\u015Fisel Hedefler ve \u0130\u015F Hedeflerinin Senkronizasyonu",
                    "Ger\xe7ek Ortakl\u0131k",
                    "Ekip Anlay\u0131\u015F\u0131",
                    "Sistem Odakl\u0131l\u0131k",
                    "Ki\u015Fisel Hatalardan \xd6\u011Frenmek",
                    "Empati",
                    "Kaynaklar\u0131 \u0130yi Kullanmak",
                    "S\xfcre\xe7 Y\xf6nelimlilik",
                    "\u0130\u015Fg\xfcc\xfcm\xfcz\xfc Etkin Kullanmak",
                    "Performans\u0131m\u0131z\u0131 Geli\u015Ftirecek Hedefler Belirlemek",
                    "Beyin F\u0131rt\u0131nas\u0131",
                    "Neden - Sonu\xe7 Diyagramlar\u0131",
                    "Etkin \u0130leti\u015Fim Kurmak",
                    "\xc7at\u0131\u015Fma Y\xf6netimi"
                ]
            },
            {
                "title": "\xc7at\u0131\u015Fma Y\xf6netimi",
                "text": "\u0130nsan ili\u015Fkilerinde ya\u015Fanan \xe7at\u0131\u015Fman\u0131n hayat\u0131n her boyutuna yans\u0131yan etkilerini irdelemek ve her d\xfczeyde ileti\u015Fim kurma becerisini geli\u015Ftirmek, bireysel ve organizasyonel hedef ve de\u011Fer anlay\u0131\u015F\u0131ndaki \xe7at\u0131\u015Fman\u0131n \xf6z\xfcn\xfc anlamak ve yine ayn\u0131 d\xfczlemde bireysel ve kurumsal uzla\u015Fma stratejileri geli\u015Ftirmenin y\xf6ntemleri",
                "list": [
                    "Teknik Olarak \u0130leti\u015Fim",
                    "\u0130leti\u015Fim ve Etkile\u015Fim Boyutu",
                    "Organizasyonel Davran\u0131\u015F ve Y\xf6netimi",
                    '"\xc7a\u011Fda\u015F Organizasyon" \u0130\xe7in Davran\u0131\u015F Modelleri',
                    "Kabuk De\u011Fi\u015Fiminin Sanc\u0131s\u0131: Organizasyonel Diren\xe7",
                    "\xc7at\u0131\u015Fma Nedenleri, T\xfcrleri",
                    "Ki\u015Fisel Tav\u0131r, De\u011Fer Yarg\u0131lar\u0131 ve Tutumlar\u0131n Analizi",
                    "Uzla\u015Fma Teknikleri",
                    "Uzla\u015Fmada Y\xf6netimsel \u0130lkeler",
                    "\xc7at\u0131\u015Fmalar\u0131 Y\xf6neten Bir Firma K\xfclt\xfcr\xfc"
                ]
            },
            {
                "title": "De\u011Fi\u015Fime Uyum",
                "text": "Kurumun t\xfcm i\u015F ve i\u015Flemlerinde, \xe7al\u0131\u015Fanlar\u0131n, ki\u015Fisel ve kurumsal ili\u015Fkilerinde ve ileti\u015Fimlerinde; Ar-Ge, planlama, karar verme, uygulama, \xfcretim, sat\u0131\u015F, pazarlama, takip, kontol ve geribildirim s\xfcre\xe7lerinde, kurumsal bir b\xfct\xfcnl\xfck ve tak\u0131msal bir ahenk sa\u011Flamak amac\u0131yla de\u011Fi\u015Fime uyumu t\xfcm detaylar\u0131 ile kat\u0131l\u0131mc\u0131lara aktarmak",
                "list": [
                    "K\xfcresel Bir Vizyona Sahip Olmak",
                    "Yenilik\xe7i, S\u0131rad\u0131\u015F\u0131, Yarat\u0131c\u0131 \xc7\xf6z\xfcm \xdcretebilmek",
                    "De\u011Fi\u015Fime Inanmak",
                    "Mevcut Sistemi Stat\xfckocu Bir D\xfc\u015F\xfcnce Ile Korumaktan ve De\u011Fi\u015Fme Direnmekten Vazge\xe7mek",
                    "De\u011Fi\u015Fimin T\xfcm Laretal Etkilerinin Fark\u0131nda Olmak",
                    "De\u011Fi\u015Fimin Gerektirdi\u011Fi Esnekli\u011Fe Sahip Olmak",
                    "De\u011Fi\u015Fimin Gerektirdi\u011Fi Do\u011Fru Stratejiyi, Kurum K\xfclt\xfcr\xfc \xc7er\xe7evesinde Uyumlu Bir Tak\u0131mda\u015Fl\u0131kla Uygulayabilmek"
                ]
            },
            {
                "title": "E\u011Fiticinin E\u011Fitimi",
                "text": "Kat\u0131l\u0131mc\u0131lara kurumsal de\u011Ferleri g\xf6z \xf6n\xfcne alarak bilgi payla\u015F\u0131m\u0131 ve aktar\u0131m\u0131n\u0131 yapabilmelerini uygulamalar ve \xf6rneklerle g\xf6stermek",
                "list": [
                    "E\u011Fitim, Yeti\u015Ftirme ve Geli\u015Ftirme",
                    "E\u011Fitimi Gerektiren Durumlar",
                    "E\u011Fitimin Ama\xe7lar\u0131",
                    "E\u011Fitim \u0130\u015Flevini Etkileyen Organizasyonel Fakt\xf6rler",
                    "E\u011Fitim Politikas\u0131n\u0131 Belirleyen Fakt\xf6rler",
                    "E\u011Fitim S\xfcreci",
                    "E\u011Fitim \u0130htiyac\u0131 Analizi",
                    "E\u011Fitim \u0130htiyac\u0131n\u0131n Belirlenmesinde Veri Kaynaklar\u0131",
                    "E\u011Fitim Programlar\u0131n\u0131n Geli\u015Ftirilmesi",
                    "\u0130\u015Fletmelerde Uygulanan E\u011Fitim Y\xf6ntemleri",
                    "E\u011Fitimin Ger\xe7ekle\u015Ftirilmesi, Sunu\u015F Becerileri",
                    "\u0130leti\u015Fimi Etkileyen Temel Fakt\xf6rler",
                    "Engellerin Giderilmesi \u0130\xe7in \u0130leti\u015Fim Kurma",
                    "\u0130leti\u015Fim Becerileri",
                    "Davran\u0131\u015F Bi\xe7imleri",
                    "\xd6\u011Fretim Modelleri",
                    "E\u011Fitimin De\u011Ferlendirilmesi"
                ]
            },
            {
                "title": "Empatik \u0130leti\u015Fim",
                "text": "\u015Eirket i\xe7inde ki\u015Filer aras\u0131 ili\u015Fkilerin, ki\u015Filik tipleri ve davran\u0131\u015F \xf6zelliklerinin empatik bir anlay\u0131\u015F ile olumlu y\xf6nde geli\u015Ftirilmesi",
                "list": [
                    "\u0130leti\u015Fim ve K\xfclt\xfcr",
                    "K\xfclt\xfcrel Farkl\u0131l\u0131klar",
                    "Ki\u015Filikler, Temel \xd6zellikler ve Ki\u015Filik Tipleri",
                    "Davran\u0131\u015Flar ve G\xfcvenli Davran\u0131\u015F \xd6zellikleri",
                    "Etkin Dinleme ve Etkin Konu\u015Fma",
                    "Kad\u0131n ve Erkek Dili",
                    "Kurum i\xe7i \u0130li\u015Fkiler ve Empati"
                ]
            },
            {
                "title": "Etkili \u0130leti\u015Fim Y\xf6ntemleri",
                "text": "Ki\u015Fileraras\u0131 ili\u015Fkileri tan\u0131mlamak, geli\u015Ftirmek ve uygulamak, \u015Firket k\xfclt\xfcr\xfc ve stratejisini destekleyerek kurum i\xe7i bar\u0131\u015F\u0131 sa\u011Flamak, kurumsal uzla\u015Fma stratejileri geli\u015Ftirmek",
                "list": [
                    "Kurum i\xe7i \u0130leti\u015Fim",
                    "\u0130leti\u015Fimde Farkl\u0131 Bak\u0131\u015F A\xe7\u0131lar\u0131ndan Bakmak",
                    "\u0130nsan \u0130li\u015Fkilerinde Kar\u015F\u0131la\u015F\u0131labilecek Engelleri \xc7\xf6z\xfcmleyebilecek Analizci Bir Bak\u0131\u015Fa Sahip Olmak",
                    "G\xfc\xe7l\xfc ve Zay\u0131f Y\xf6nlerimizin Fark\u0131nda Olmak",
                    "\u0130leti\u015Fime Etki Eden \xd6zelliklerimiz",
                    "Bask\u0131n Ki\u015Filik \xd6zelliklerimiz",
                    "Do\u011Fru Anlamak ve Anla\u015F\u0131lmak",
                    "Bireysel ve Kurumsal Uzla\u015Fma Stratejileri Geli\u015Ftirmek",
                    "\u015Eirket i\xe7i \xc7at\u0131\u015Fmalar\u0131 \xd6nlemenin Yollar\u0131n\u0131 Tan\u0131mlamak",
                    "Organizasyonel Davran\u0131\u015F",
                    "Ki\u015Fisel Tav\u0131r, De\u011Fer ve Tutumlar\u0131n Analizi",
                    "Ki\u015Fileraras\u0131 Ama\xe7, Hedef ve De\u011Fer Yarg\u0131lar\u0131"
                ]
            },
            {
                "title": "\u0130\u015Fyeri Psikolojisi",
                "text": "\xc7al\u0131\u015Fanlar\u0131n kendilerini daha rahat ifade etmeleri, ki\u015Fileraras\u0131 ili\u015Fkiler, i\u015Fbirli\u011Fi ve i\xe7sel motivasyonun artt\u0131r\u0131lmas\u0131",
                "list": [
                    "\u015Eirket Mensubu Olarak Bireysel Misyon",
                    "Bu I\u015Fyerinde \xc7al\u0131\u015Fman\u0131n G\xfc\xe7l\xfc Yanlar\u0131n\u0131n Belirlenmesi",
                    "Bu I\u015Fyerinde Ya\u015Fanan Zorluklar\u0131n Belirlenmesi",
                    "Ki\u015Fileraras\u0131 \u0130li\u015Fkiler",
                    "\xc7al\u0131\u015Fanlar Aras\u0131 \u0130\u015Fbirli\u011Fi ve G\xfcven",
                    "\u0130\xe7sel Motivasyonun Artt\u0131r\u0131lmas\u0131",
                    "Bireysel Performans\u0131n Geli\u015Ftirilmesi",
                    "\u0130\u015Fyerinde Stres",
                    "\u0130\u015F G\xfcvenli\u011Fi ve \u0130\u015Fg\xf6ren Sa\u011Fl\u0131\u011F\u0131"
                ]
            },
            {
                "title": "Kendine G\xfcveni Geli\u015Ftirme",
                "text": "Kurumsal temel de\u011Fer ve ilkelerle \xf6rt\xfc\u015Fen ki\u015Fisel prensipler geli\u015Ftirme ve zor anlarda bu ilkelere uyman\u0131n sa\u011Flanmas\u0131",
                "list": [
                    "\u0130lkelerine Ba\u011Fl\u0131 Kalarak Ba\u015Fkalar\u0131n\u0131n G\xfcven ve Sayg\u0131s\u0131n\u0131 Kazanmak",
                    "Zor Zamanlarda Ba\u015Faraca\u011F\u0131na Olan Inanc\u0131n\u0131 Kaybetmemek",
                    "Zor Olan Do\u011Fru ve Etkili Kararlar\u0131 Zor Anlarda Dahi Alabilmek",
                    "Pes Etmeden Devam Etmek",
                    "Kurumsal Hedeflere Olan Inanc\u0131n\u0131 Y\xfcksek Tutmak",
                    "Ba\u015Far\u0131ya ve \xc7\xf6z\xfcme Odaklanmak",
                    "Zor Anlar\u0131, Kendini K\xf6t\xfc Hissetme Duygusuna Kap\u0131lmadan Y\xfcksek Bir Motivasyonla Ge\xe7ebilmek"
                ]
            },
            {
                "title": "Ki\u015Fileraras\u0131 \u0130li\u015Fki Becerilerini Geli\u015Ftirme",
                "text": "Ki\u015Fileraras\u0131 \xe7\u0131kabilecek ileti\u015Fim engelleri ve \xe7at\u0131\u015Fmalar\u0131n uzla\u015Fma stratejileri geli\u015Ftirerek a\u015F\u0131lmas\u0131, ki\u015Filerin ama\xe7, hedef ve de\u011Fer yarg\u0131lar\u0131 b\xfct\xfcnl\xfc\u011F\xfcn\xfc sa\u011Flayarak, \xe7al\u0131\u015Fanlar aras\u0131 i\u015Fbirli\u011Fi ve g\xfcvenin olu\u015Fturulmas\u0131",
                "list": [
                    "\u0130leti\u015Fimde Farkl\u0131 Bak\u0131\u015F A\xe7\u0131lar\u0131ndan Bakmak",
                    "\u0130nsan \u0130li\u015Fkilerinde Kar\u015F\u0131la\u015F\u0131labilecek Engelleri \xc7\xf6z\xfcmleyebilecek Analizci Bir Bak\u0131\u015Fa Sahip Olmak",
                    "\u0130\u015Fyerinde Stres",
                    "G\xfc\xe7l\xfc ve Zay\u0131f Y\xf6nlerimizin Fark\u0131nda Olmak",
                    "Bask\u0131n Ki\u015Filik \xd6zelliklerimiz",
                    "Bireysel ve Kurumsal Uzla\u015Fma Stratejileri Geli\u015Ftirmek",
                    "\u015Eirket i\xe7i \xc7at\u0131\u015Fmalar\u0131 \xd6nlemenin Yollar\u0131n\u0131 Tan\u0131mlamak",
                    "Organizasyonel Davran\u0131\u015F",
                    "Ki\u015Fisel Tav\u0131r, De\u011Fer ve Tutumlar\u0131n Analizi",
                    "Ki\u015Fileraras\u0131 Ama\xe7, Hedef ve De\u011Fer Yarg\u0131lar\u0131",
                    "\xc7al\u0131\u015Fanlar Aras\u0131 I\u015Fbirli\u011Fi ve G\xfcven"
                ]
            },
            {
                "title": "M\xfc\u015Fteri Memnuniyeti \xd6l\xe7me Teknikleri",
                "text": "\xc7a\u011Fda\u015F y\xf6netim yakla\u015F\u0131mlar\u0131ndan M\xfc\u015Fteri Odakl\u0131l\u0131k felsefesinde, m\xfc\u015Fterilerin tatminini \xf6l\xe7mek i\xe7in planlama, analiz etme, uygulama ve raporlama konular\u0131nda kat\u0131l\u0131mc\u0131lara bilgi vermek ve bu konularda karar alma becerilerini geli\u015Ftirmek",
                "list": [
                    "M\xfc\u015Fteri Hizmetleri Y\xf6netimi ve M\xfc\u015Fteri Tatmini Felsefesi",
                    "M\xfc\u015Fterilerinizin Beklentileri Nedir?",
                    "Neyi \xd6l\xe7mek \u0130stiyorsunuz? \u2013 Temel \xd6l\xe7\xfcm Konular\u0131n\u0131n Belirlenmesi",
                    "\u015Eirketiniz ve M\xfc\u015Fterileriniz \u0130\xe7in En \u0130yi Ara\u015Ft\u0131rma Tekni\u011Finin Se\xe7imi",
                    "En S\u0131k Ba\u015Fvurulan Ara\u015Ft\u0131rma Tekni\u011Fi: Anket",
                    "\xd6l\xe7\xfcm Haz\u0131rl\u0131\u011F\u0131 ve Verilerin Toplanmas\u0131",
                    "M\xfc\u015Fteri Tatmini \xd6l\xe7\xfcm\xfc Analizi ve Sonu\xe7lar\u0131n\u0131n De\u011Ferlendirilmesi",
                    "Analiz Sonu\xe7lar\u0131n\u0131 Raporlamak",
                    "Analiz Sonu\xe7lar\u0131n\u0131n \u015Eirket Yap\u0131s\u0131na ve Stratejilerine Etkisi",
                    "M\xfc\u015Fteri Beklentilerindeki De\u011Fi\u015Fiklikleri \u0130zlemek",
                    "Gelece\u011Fi Planlamak"
                ]
            },
            {
                "title": "M\xfczakere Teknikleri",
                "text": "M\xfczakere s\xfcrecini tart\u0131\u015Fmaya a\xe7arak, iki taraf i\xe7in ba\u015Far\u0131l\u0131 bir m\xfczakerenin \u015Fartlar\u0131n\u0131 ortaya koymak, m\xfczakereci davran\u0131\u015Flar\u0131n\u0131n temel belirleyicilerinden hareketle; m\xfczakere stratejileri, m\xfczakerede manevra, oyunlar ve taktikler uygulamal\u0131 bir \u015Fekilde g\xfcndeme getirmek",
                "list": [
                    "M\xfczakere Nedir ve Ni\xe7in Yap\u0131l\u0131r?",
                    "M\xfczakere S\xfcrecinin Temel Unsurlar\u0131",
                    "M\xfczakereci Kar\u015F\u0131 Taraf \u0130li\u015Fkisi",
                    "M\xfczakerede Dikkat Edilmesi Gereken Hususlar",
                    "M\xfczakere S\xfcrecinin A\u015Famalar\u0131",
                    "M\xfczakere Stratejileri",
                    "M\xfczakerelerde Manevra ve Oyunlar",
                    "M\xfczakere Teknikleri",
                    "M\xfczakere Becerileri",
                    "\u0130dari ve Ticari M\xfczakereler",
                    "M\xfczakere S\xfcrecinde Yasal Fakt\xf6rler"
                ]
            },
            {
                "title": "Neuro Linguistic Programming",
                "text": "Ki\u015Filerin ama\xe7lar\u0131na ula\u015Fmalar\u0131 i\xe7in n\xf6rolojik programlar\u0131n\u0131 ke\u015Ffetmelerini ve en iyi \u015Fekilde kullanmalar\u0131n\u0131 sa\u011Flamay\u0131 hedefleyen, tart\u0131\u015Fmal\u0131 bir psikolojik terapi anlay\u0131\u015F\u0131",
                "list": [
                    "NLP\u2019nin Do\u011Fu\u015Fu",
                    "NLP\u2019nin A\xe7\u0131l\u0131m\u0131",
                    "NLP\u2019nin \xd6n Kabulleri - \u0130lkeleri",
                    "Dilimiz, \u0130leti\u015Fimimiz ve Davran\u0131\u015F\u0131m\u0131z",
                    "\u0130nsan Denilen Varl\u0131k",
                    "NLP\u2019de Temsil Sistemleri",
                    "NLP\u2019de Alg\u0131m\u0131z\u0131 Etkileyen Fakt\xf6rler",
                    "NLP\u2019de Davran\u0131\u015F\u0131 Anlamak",
                    "NLP\u2019de Stratejiler ve Yeniden \xc7er\xe7evelemek"
                ]
            },
            {
                "title": "Ofis Y\xf6netimi",
                "text": "Etkili ve verimli bir ofis y\xf6netimi i\xe7in gerekli ko\u015Fullar\u0131n de\u011Ferlendirmesini yaparak, b\xfcro y\xf6netimi ve organizasyon, ofis d\xfczeni, resmi ve i\u015F yaz\u0131lar\u0131, evrak \xfcretimi, dosyalama, evrak y\xf6netimi ve ar\u015Fiv gibi ofis uygulamalar\u0131 hakk\u0131nda bilgi vermek",
                "list": [
                    "Ofis Y\xf6netimi ve Organizasyon",
                    "Ofiste Belge \xdcretimi ve T\xfcrleri",
                    "Yaz\u0131\u015Fma Y\xf6ntemi",
                    "Evrak Y\xf6netimi ve Ar\u015Fiv"
                ]
            },
            {
                "title": "Pazarl\u0131k, \u0130kna, M\xfczakere Becerilerini Geli\u015Ftirme",
                "text": "Bir sat\u0131\u015F g\xf6r\xfc\u015Fmesinde sat\u0131c\u0131lar\u0131n, \xfcr\xfcn, fikir ve hizmetlerini kar\u015F\u0131l\u0131kl\u0131 yarar sa\u011Flayacak ko\u015Fullarda satabilmeleri, bir m\xfczakerenin nas\u0131l planlanmas\u0131 ve uygulanmas\u0131 gerekti\u011Fine ili\u015Fkin y\xf6ntem ve teknikler",
                "list": [
                    "Pazarl\u0131k - \u0130kna - M\xfczakere Aras\u0131ndaki Farkl\u0131l\u0131klar",
                    "M\xfczakere S\xfcreci",
                    "Planlama ve Haz\u0131rl\u0131k S\xfcrecinde Yap\u0131lmas\u0131 Gerekenler",
                    "M\xfczakere Stilleri ve Uygulamalar\u0131",
                    "Kar\u015F\u0131la\u015F\u0131lan Kar\u015F\u0131 Taktikler ve \xd6nlemler",
                    "M\xfczakerelerde Strateji Geli\u015Ftirme"
                ]
            },
            {
                "title": "Perakendecilikte Sunum ve Sat\u0131\u015F",
                "text": "Perakende sekt\xf6r\xfcnde faaliyet g\xf6steren i\u015Fletmelerde m\xfc\u015Fteri memnuniyetini yaratacak, \xe7al\u0131\u015Fanlarda hizmet farkl\u0131l\u0131\u011F\u0131n\u0131 ortaya koyacak sunum ve sat\u0131\u015F s\xfcrecinde etkili yakla\u015F\u0131mlar\u0131 geli\u015Ftirmek",
                "list": [
                    "Perakendecilikte M\xfc\u015Fteri Hizmeti Yakla\u015F\u0131m\u0131",
                    "Kaliteli Hizmetin Fark Yaratan Unsurlar\u0131",
                    "Sekt\xf6rlere G\xf6re \xdcr\xfcn ve Hizmet Sunumu",
                    "M\xfc\u015Fteri Tipleri ve Yakla\u015F\u0131mlar",
                    "M\xfc\u015Fterilerin Ihtiya\xe7lar\u0131n\u0131n Tespiti",
                    "K\u0131s\u0131tl\u0131 Zamandaki Sat\u0131\u015F S\xfcreci",
                    "Haz\u0131rl\u0131k ve Etkili Sunumun Getirileri",
                    "\xdcr\xfcn Bilgisinin Do\u011Fru \u015Eekilde Sunumu",
                    "Sat\u0131\u015F\u0131 Ger\xe7ekle\u015Ftirmek ve \xc7apraz Sat\u0131\u015F",
                    "M\xfc\u015Fteri Memnuniyeti ve Ba\u011F\u0131ml\u0131l\u0131\u011F\u0131 Yaratma"
                ]
            },
            {
                "title": "Pozitif D\xfc\u015F\xfcnce ile Mutlak Ba\u015Far\u0131",
                "text": "D\xfc\u015F\xfcnceyi olu\u015Fturan kal\u0131plar\u0131n nas\u0131l kazan\u0131ld\u0131\u011F\u0131, g\xfcn\xfcm\xfcz\xfcn gerektirdi\u011Fi s\u0131n\u0131r\u0131n \xf6tesinde d\xfc\u015F\xfcnme yetene\u011Finin kazan\u0131lmas\u0131 i\xe7in yap\u0131lacaklar ve bu kazan\u0131lan sistemle, problemlerin \xe7\xf6z\xfcm\xfcne nas\u0131l bakarak karar verebilece\u011Fimiz, pozitif enerjiyi olu\u015Fturacak olan Pozitif D\xfc\u015F\xfcnme sisteminin kazan\u0131lmas\u0131",
                "list": [
                    "Farkl\u0131 D\xfc\u015F\xfcnce Yap\u0131s\u0131n\u0131n Kazan\u0131lmas\u0131",
                    "Pozitif D\xfc\u015F\xfcncenin Ay\u0131rt Edilmesi",
                    "Kendini Tan\u0131ma-Testler",
                    "Pozitif D\xfc\u015F\xfcncede Engeller",
                    "Stresin Fizyolojik Ve Psikolojik Yap\u0131s\u0131",
                    "Stres Ve Ba\u015Fa  \xc7\u0131kma",
                    "Negatiflerle Ba\u015Fa \xc7\u0131kma",
                    "Pozitif D\xfc\u015F\xfcnceyi Te\u015Fvik",
                    "Pozitif D\xfc\u015F\xfcnceyi Kazanma",
                    "S\u0131n\u0131rlar\u0131m\u0131z\u0131 Tan\u0131ma-S\u0131n\u0131r\u0131n \xd6tesinde D\xfc\u015F\xfcnebilme",
                    "Kendi Kendini Motive Etmede Pozitif D\xfc\u015F\xfcncenin Yeri",
                    "Pozitif Enerjinin Kullan\u0131lmas\u0131",
                    "Ba\u015Far\u0131da Pozitif D\xfc\u015F\xfcncenin Yeri",
                    "Beklentilerin Yeniden G\xf6zden Ge\xe7irilmesi",
                    "Problemin \xc7\xf6z\xfcm\xfcndeki Bak\u0131\u015F A\xe7\u0131s\u0131",
                    "Zihinsel Jimnastikler",
                    "Sa\u011F Beyin Yar\u0131m K\xfcresinin Kullan\u0131lmas\u0131",
                    "\xc7\xf6z\xfcm Bulman\u0131n Planlanmas\u0131",
                    "Hayal G\xfcc\xfc Tekni\u011Fi",
                    "Problem \xc7\xf6zme Stratejisini Geli\u015Ftirme",
                    "Karar Vermede Verilerin G\xf6zden Ge\xe7irilmesi",
                    "Beyin F\u0131rt\u0131nas\u0131",
                    "Kararlarda Etki Alt\u0131nda Kalmama",
                    "Grup Karar\u0131",
                    "Ba\u015Far\u0131y\u0131 Olu\u015Fturma"
                ]
            },
            {
                "title": "Proje Y\xf6netimi",
                "text": "Belirli ama\xe7lar \xe7er\xe7evesinde haz\u0131rlanacak projelerde, proje ekiplerinin ba\u015Far\u0131l\u0131 olabilmesi i\xe7in nelerin yap\u0131lmas\u0131 gerekti\u011Fini \xf6rneklerle tart\u0131\u015Fmaya a\xe7mak",
                "list": [
                    "Proje Y\xf6netiminden Beklenenler",
                    "Proje Safhalar\u0131 ve Proje Hayat D\xf6ng\xfcs\xfc",
                    "Proje Payda\u015Flar\u0131",
                    "Organizasyonel Etkiler",
                    "Genel Y\xf6netim Becerileri",
                    "Proje S\xfcre\xe7leri",
                    "S\xfcre\xe7 Gruplar\u0131 ve Etkile\u015Fimleri",
                    "Proje Kapsam\u0131",
                    "Projelerde Zaman Y\xf6netimi",
                    "Projelerde Maliyet Y\xf6netimi",
                    "Projelerde Kalite Y\xf6netimi",
                    "Projelerde \u0130nsan Kaynaklar\u0131 Y\xf6netimi",
                    "Projelerde \u0130leti\u015Fim Y\xf6netimi",
                    "Projelerde Sat\u0131nalma Y\xf6netimi",
                    "Projelerde \xc7izelgeleme",
                    "Kat\u0131l\u0131mc\u0131lar\u0131 Tan\u0131mak",
                    "\u0130nsanlarla \xc7al\u0131\u015Fma ve Onlar\u0131 Y\xf6netme",
                    "Liderlik",
                    "Projelerde Takip ve Kontrol"
                ]
            },
            {
                "title": "Raporlama Teknikleri",
                "text": "Rapor haz\u0131rlama, raporlaman\u0131n \xf6nemi, rapor tipleri ve i\xe7erikleri ile raporlama standartlar\u0131n\u0131n a\xe7\u0131klanmas\u0131",
                "list": [
                    "Rapor Haz\u0131rlama",
                    "Raporlama T\xfcrleri",
                    "\u0130\xe7erik Y\xf6n\xfcnden Raporlar",
                    "Raporun B\xf6l\xfcmleri",
                    "Raporda Yaz\u0131m Kurallar\u0131",
                    "Rapor Konusundaki Temel \u015Eikayetler",
                    "\u0130yi Rapor Yazmay\u0131 Engelleyen Fakt\xf6rler"
                ]
            },
            {
                "title": "Stres Y\xf6netimi",
                "text": "Kat\u0131l\u0131mc\u0131lar\u0131 i\u015F d\xfcnyas\u0131nda kar\u015F\u0131 kar\u015F\u0131ya kald\u0131klar\u0131 stres konusunda ayd\u0131nlatmak, kapsaml\u0131 ve etkili ba\u015Fa \xe7\u0131kma yollar\u0131 hakk\u0131nda tart\u0131\u015Farak \xe7\xf6z\xfcm yollar\u0131 \xfczerinde konu\u015Fmak amac\u0131yla haz\u0131rlanm\u0131\u015Ft\u0131r.",
                "list": [
                    "Stres ve Hayat\u0131m\u0131zdaki \xd6nemi",
                    "Stresi Tan\u0131yor Musunuz?",
                    "Stresi Hangi Ko\u015Fullarda Ya\u015F\u0131yoruz?",
                    "Stres D\xfczeyimizi Neler Etkiler?",
                    "Stres Belirtileri",
                    "Stres Nas\u0131l Kontrolden \xc7\u0131kar?",
                    "Stresle Ba\u015F Etmede Olumsuz Etmenler",
                    "Stresin Sa\u011Fl\u0131\u011F\u0131m\u0131za Etkisi",
                    "Keyifli ve Ba\u015Far\u0131l\u0131 Bir I\u015F Hayat\u0131 I\xe7in En Uygun Stres Seviyesini Bulmak",
                    "Stresi Tan\u0131mak ve I\u015F D\xfcnyas\u0131nda Motivasyon Arac\u0131 Olarak Kullanmak"
                ]
            },
            {
                "title": "Tak\u0131m \xc7al\u0131\u015Fmas\u0131",
                "text": "Tak\u0131m \xe7al\u0131\u015Fmas\u0131n\u0131n \xf6nemini ve faydalar\u0131n\u0131, nas\u0131l ger\xe7ekle\u015Febilece\u011Fini ve gerekli becerileri uygulamal\u0131 bir bi\xe7imde aktarma",
                "list": [
                    "Tak\u0131m \xc7al\u0131\u015Fmas\u0131n\u0131n \xd6nemi",
                    "Kalabal\u0131k Tak\u0131m\u0131 Belirleyen \xd6zellikler",
                    "Tak\u0131m\u0131 Ba\u015Far\u0131s\u0131zl\u0131\u011Fa U\u011Fratan Fakt\xf6rler",
                    "Tak\u0131m Olu\u015Fturma Y\xf6ntemleri",
                    "Tak\u0131m \xc7al\u0131\u015Fmas\u0131nda Roller ve Sorumluluklar",
                    "Tak\u0131mda Y\xf6nlendirme ve Motivasyon",
                    "Tak\u0131m \xc7al\u0131\u015Fmas\u0131 Nas\u0131l Y\xfcr\xfct\xfcl\xfcr, Y\xf6netilir?",
                    "Tak\u0131m \xc7al\u0131\u015Fmas\u0131 Becerileri ve Ara\xe7lar\u0131",
                    "\xc7at\u0131\u015Fma Y\xf6netimi ve Uzla\u015Fma Teknikleri",
                    "Liderlik ve Rehberlik Becerileri",
                    "Tak\u0131mda\u015Fl\u0131kta 3 Alan: Kalite, Verimlilik ve \u0130li\u015Fkiler",
                    "Tak\u0131mda\u015Fl\u0131k I\xe7in: Sorumluluk, Ba\u011Fl\u0131l\u0131k ve \u0130nisiyatif"
                ]
            },
            {
                "title": "Telefonda \u0130leti\u015Fim Teknikleri",
                "text": "\xc7al\u0131\u015Fanlar\u0131n ileti\u015Fim konusundaki becerilerini g\xf6stermede \xf6nemli bir ara\xe7 olan telefonun kullan\u0131m\u0131, etkinli\u011Fi gibi konular\u0131 uygulamal\u0131 olarak kat\u0131l\u0131mc\u0131lara aktarmak",
                "list": [
                    "Telefon Konu\u015Fmalar\u0131",
                    "Telefona Yan\u0131t Verme",
                    "Telefonun Tehlikeleri",
                    "Do\u011Fru Konu\u015Fma Nas\u0131l Olmal\u0131",
                    "Sizin Arad\u0131\u011F\u0131n\u0131z Telefonlar",
                    "Telefonda \u0130\u015F Konu\u015Fma Y\xf6ntemleri",
                    "Telefonda Kendini Do\u011Fru \u0130fade Etme",
                    "Telefonu Kapatma"
                ]
            },
            {
                "title": "Uygulamal\u0131 Sunum Teknikleri",
                "text": "Etkin sunum tekniklerini uygulamal\u0131 bir bi\xe7imde aktarmak, etkili konu\u015Fma ve stratejilere ili\u015Fkin uygulamalar",
                "list": [
                    "Ba\u015Flamadan \xd6nce Yap\u0131lmas\u0131 Gerekenler \xd6n Haz\u0131rl\u0131klar",
                    "D\xfc\u015F\xfcncelerin D\xfczenlenmesi",
                    "Sunu\u015Fa Son \u015Eeklini Vermek",
                    "Prova Yapmak",
                    "Sunumda Etkiyi Artt\u0131rma",
                    "Sinirlerin Denetlenmesi",
                    "G\xfc\xe7l\xfc Bir Etki Yaratma",
                    "G\xf6rsel Ara\xe7lar\u0131n Etkin Olarak Kullan\u0131lmas\u0131",
                    "Sorular ve Cevapland\u0131rma",
                    "G\xfc\xe7 Durumlar\u0131n Ele Al\u0131nmas\u0131",
                    "Etkili Konu\u015Fma \u0130\xe7in 10 Temel Kural",
                    "Stratejilere \u0130li\u015Fkin Uygulamalar"
                ]
            },
            {
                "title": "\xdcst\xfcn Hizmet \u0130\xe7in Ortak Bilin\xe7 Olu\u015Fturma",
                "text": "Daha iyiye yolculuk hareketinde; ortak bilince ula\u015Fabilmek, temel y\xf6netim ilkelerini payla\u015Fmak, topyek\xfcn kat\u0131l\u0131m\u0131 sa\u011Flamada engelleri tan\u0131yarak, bu alanlara odaklanmak, s\xfcre\xe7lerimizin iyile\u015Ftirilmesine y\xf6nelik \xe7al\u0131\u015Fmalar\u0131 ba\u015Flatmak",
                "list": [
                    "Kalite, Rekabet Etmede Bir Avantajd\u0131r",
                    "Organizasyon K\xfclt\xfcr\xfcn\xfcn Etkilerini Tan\u0131mak",
                    "Planl\u0131 Hareket i\xe7in Yap\u0131lanma",
                    "S\xfcrekli Geli\u015Fme ve Y\xf6ntemleri",
                    "Herkesin Kat\u0131l\u0131m\u0131n\u0131 Sa\u011Flamak",
                    "S\u0131f\u0131r Hata Anlay\u0131\u015F\u0131",
                    "M\xfc\u015Fteri Odakl\u0131 Yakla\u015F\u0131m\u0131n Benimsenmesi",
                    "Toplam Kalite Bir S\xfcre\xe7tir",
                    "\u0130statistiki Tekni\u011Fin Tan\u0131t\u0131m ve Kullan\u0131m\u0131",
                    "\u0130\xe7 M\xfc\u015Fterileri Memnun Etmek",
                    "Muayene De\u011Fil, \xd6nleme Yakla\u015F\u0131m\u0131",
                    "Tedarikten M\xfc\u015Fteriye S\xfcre\xe7",
                    "B\xfcrokrasi ve Olas\u0131 Engellerin Tan\u0131nmas\u0131"
                ]
            },
            {
                "title": "Yarat\u0131c\u0131 D\xfc\u015F\xfcnme",
                "text": "\xc7al\u0131\u015Fanlar\u0131n ki\u015Fisel ve kurumsal ili\u015Fkilerinde ve ileti\u015Fimlerinde; planlama, karar verme, uygulama, takip, kontol ve geri bildirim s\xfcre\xe7lerinde, s\u0131rad\u0131\u015F\u0131 d\xfc\u015F\xfcnce g\xfcc\xfcne ula\u015F\u0131p, yeni y\xf6ntemler geli\u015Ftirmelerini sa\u011Flamay\u0131 ama\xe7lamak",
                "list": [
                    "D\xfc\u015F\xfcncelerinde Esnek Olmak",
                    "Ortaya \xc7\u0131kan Problemlere Farkl\u0131 \xc7\xf6z\xfcmler Getirebilmek",
                    "Ger\xe7ek\xe7i Planlara D\xf6n\xfc\u015Ft\xfcr\xfclebilen Yeni \u0130\u015F Anlay\u0131\u015Flar\u0131 Yaratmak",
                    "S\u0131rad\u0131\u015F\u0131 D\xfc\u015F\xfcnce G\xfcc\xfcn\xfc \u0130\u015F Hayat\u0131na Uygulayabilmek",
                    "S\u0131rad\u0131\u015F\u0131 Kararlar \u0130le Farkl\u0131l\u0131k Yaratabilmek",
                    "Performans\u0131 Artt\u0131rmak \u0130\xe7in Yeni Fikirler Ortaya \xc7\u0131karmak",
                    "Metodlar, S\xfcre\xe7ler Yaratmak ve Uygulamak"
                ]
            },
            {
                "title": "Zaman Y\xf6netimi",
                "text": "\u0130nsan\u0131n kendisinin ya\u015Fama konu\u015Flan\u0131\u015F \u015Fekli ve zaman kar\u015F\u0131s\u0131ndaki tavr\u0131 ile ilgili fark\u0131ndal\u0131\u011F\u0131n\u0131 artt\u0131rmak, tavr\u0131m\u0131z\u0131n ve ama\xe7lar\u0131m\u0131z\u0131n zaman y\xf6netimi \xfczerindeki etkileri netle\u015Ftirilerek, zaman y\xf6netimi tuzaklar\u0131 ve bu tuzaklardan korunma stratejileri \xfczerinde odaklanmak",
                "list": [
                    "Ba\u015Fkalar\u0131ndan \xd6nce Kendimizi Y\xf6netmek",
                    "Zaman Kontrol\xfcn\xfcn En \xd6nemli Ko\u015Fullar\u0131",
                    "Zaman Tuzaklar\u0131, \xd6ncelikleri Bilmek, Ertelemek, Acelecilik, Karars\u0131zl\u0131k",
                    "Verimsiz Toplant\u0131lar, Da\u011F\u0131n\u0131k Masa",
                    "Hay\u0131r Diyememek",
                    "Zaman\u0131 Iyi Kullanman\u0131n Yollar\u0131",
                    "K\u0131s\u0131tl\u0131 Zaman Stresinden Kurtulman\u0131n  Anahtar\u0131",
                    "Zaman\u0131n\u0131 Y\xf6netememenin Bedeli",
                    "Zaman\u0131m\u0131z\u0131 Y\xf6netmekle \u0130lgili K\xf6t\xfc Al\u0131\u015Fkanl\u0131klar\u0131m\u0131z",
                    "Zaman Y\xf6netiminin Temel Felsefesi",
                    "Zaman\u0131 Planlamak: (Covey'in Zaman Y\xf6netimi Matrisi)",
                    "Zaman Tuzaklar\u0131 Nereye Gizlenir?",
                    "\xd6ncelikleri ve Acil \u0130\u015Fleri Belirlemek",
                    "Eylem Plan\u0131 \u2013 \xd6neriler"
                ]
            }
        ]
    },
    {
        "title": "Y\xf6netim Programlar\u0131",
        "list": [
            {
                "title": "Coaching: Ko\xe7 Yeti\u015Ftirme Program\u0131",
                "text": "Kurulu\u015Flar\u0131n ba\u015Far\u0131s\u0131n\u0131 direkt etkileyen insan kayna\u011F\u0131n\u0131n i\u015F tatminini sa\u011Flama ve kuruma ba\u011Fl\u0131l\u0131\u011F\u0131 ile verimlili\u011Fe kat\u0131l\u0131m\u0131n\u0131 sa\u011Flamada liderlik becerileri \xfczerinde d\xfc\u015F\xfcnmek ve bu becerileri geli\u015Ftirmek",
                "list": [
                    "Y\xf6nlendirmenin Mucizesi",
                    "Coaching Tan\u0131m\u0131, Benzer Kavramlardan Fark\u0131",
                    "Y\xf6netici \u2013 Ko\xe7 (Coach) Kavramlar\u0131",
                    "Y\xf6netim Yelpazesi",
                    "Sizin Tarz\u0131n\u0131z",
                    "Kat\u0131l\u0131mc\u0131l\u0131k ve Durumsal Yakla\u015F\u0131m Modelleri",
                    "Etkili Bir Coaching S\xfcrecinin Tan\u0131nmas\u0131",
                    "Coaching Yeteneklerini Geli\u015Ftirme",
                    "\u0130nsan Davran\u0131\u015Flar\u0131n\u0131n \u0130ncelenmesi (Maslow)",
                    "Beceri ve \u0130steklerin Uyumland\u0131r\u0131lmas\u0131",
                    "Coaching Becerilerinde \u0130leti\u015Fim \u2013 Etkile\u015Fim",
                    "Dinleme Becerisi",
                    "Coaching Y\xf6nteminin \xc7al\u0131\u015Fmas\u0131 (Geri Bildirim)",
                    "Coaching Yakla\u015F\u0131m\u0131nda A\u015Famalar",
                    "Bir Coaching Oturumunun Ana Ba\u015Fl\u0131klar\u0131"
                ]
            },
            {
                "title": "\xc7a\u011Fda\u015F Motivasyon Teknikleri",
                "text": "Ekipteki \xe7al\u0131\u015Fanlar\u0131n motivasyonunu artt\u0131rmay\u0131 hedefleyen y\xf6neticilerin, hangi yol ve y\xf6ntemlerle bunu sa\u011Flayacaklar\u0131n\u0131 t\xfcm detaylar\u0131 ile aktarmak",
                "list": [
                    "Motivasyonun Tan\u0131m\u0131 ve Motivasyon S\xfcrecinin Kurulu\u015F A\u015Famalar\u0131",
                    "Motivasyon Ara\xe7lar\u0131n\u0131n Belirlenmesi",
                    "Sosyo \u2013 ekonomik Ara\xe7lar ile Motivasyonun Sa\u011Flanmas\u0131",
                    "\xd6rg\xfctsel ve Y\xf6netsel Ara\xe7lar ile Motivasyonun Sa\u011Flanmas\u0131",
                    "Motivasyon Teorileri",
                    "\xc7al\u0131\u015Fan Beklentilerinin \u0130ncelenmesi",
                    "Motivasyon Nas\u0131l Art\u0131rma Teknikleri",
                    "Y\xf6neticilerin Neler Yapmas\u0131 Gerekti\u011Finin Belirlenmesi",
                    "\xc7al\u0131\u015Fanlar\u0131n G\xfcvenini Artt\u0131rma Y\xf6ntemleri",
                    "Takdir Etmenin \xd6nemli Unsurlar\u0131 ve Y\xf6ntemleri",
                    "Kurumsal Ba\u015Far\u0131n\u0131n S\u0131rr\u0131",
                    "Bireysel Motivasyon Sa\u011Flay\u0131c\u0131 \xc7al\u0131\u015Fma Prensipleri",
                    "\xc7al\u0131\u015Fanlar\u0131n Moral Y\xf6netimi",
                    "\xc7al\u0131\u015Fanlar\u0131n Motivasyonunu Saptama Anketi",
                    "\xc7al\u0131\u015Fanlar\u0131n Beklentileri Anketi Uygulamas\u0131",
                    "Davran\u0131\u015F Belirleme Anketi Uygulamas\u0131"
                ]
            },
            {
                "title": "De\u011Fi\u015Fim Y\xf6netimi",
                "text": "De\u011Fi\u015Fimi sistem felsefesi b\xfct\xfcnl\xfc\u011F\xfcyle yaratabilme ve y\xf6netebilme, de\u011Fi\u015Fimin gerektirdi\u011Fi do\u011Fru stratejinin, kurum k\xfclt\xfcr\xfc \xe7er\xe7evesinde uyumlu tak\u0131mlar kurarak uygulanmas\u0131n\u0131n sa\u011Flanmas\u0131",
                "list": [
                    "De\u011Fi\u015Fimi Sistem Felsefesi B\xfct\xfcnl\xfc\u011F\xfcyle Yaratabilmek ve Y\xf6netebilmek",
                    "\xc7al\u0131\u015Fanlar\u0131n De\u011Fi\u015Fime \u0130nanmas\u0131n\u0131 Sa\u011Flamak",
                    "De\u011Fi\u015Fimi A\xe7\u0131klayabilmek",
                    "Mevcut Sistemi Koruyan ve De\u011Fi\u015Fme Direnmekten Vazge\xe7meyen \xc7al\u0131\u015Fanlar\u0131n De\u011Fi\u015Fime \u0130kna Edilmesi",
                    "\xc7al\u0131\u015Fanlarda De\u011Fi\u015Fimin Gerektirdi\u011Fi Esnekli\u011Fin Sa\u011Flanmas\u0131",
                    "De\u011Fi\u015Fimin Gerektirdi\u011Fi Do\u011Fru Stratejinin, Kurum K\xfclt\xfcr\xfc \xc7er\xe7evesinde Uyumlu Tak\u0131mlar Kurarak Uygulanmas\u0131n\u0131n Sa\u011Flanmas\u0131"
                ]
            },
            {
                "title": "Etkili Liderlik ve Vizyon Geli\u015Ftirme",
                "text": "\u015Eirket stratejisini ve \u015Firket k\xfclt\xfcr\xfcn\xfc birle\u015Ftirebilen liderlerin hem geni\u015F bir vizyon sahibi olmalar\u0131n\u0131 hem de bu vizyonu uygulayabilecek becerilere sahip olmalar\u0131n\u0131 sa\u011Flanmas\u0131",
                "list": [
                    "Etkin Liderlik Fonksiyonlar\u0131",
                    "Planlama ve Organize Etme",
                    "Grup Dinamiklerini Y\xf6nlendirme",
                    "\u0130leti\u015Fim S\xfcreci ve Ileti\u015Fim Kanallar\u0131n\u0131 Etkin Kullanma",
                    "Geri Bildirim Alma ve Verme S\xfcreci",
                    "Yeni Y\xf6netsel Ger\xe7ekler",
                    "Vizyon ve Ba\u015Far\u0131",
                    "Vizyonun Geli\u015Ftirilmesi",
                    "De\u011Fi\u015Fik Liderlik Tarzlar\u0131n\u0131n G\xf6zden Ge\xe7irilmesi"
                ]
            },
            {
                "title": "Hedeflerle Y\xf6netim",
                "text": "\xc7al\u0131\u015Fanlar\u0131n son derece net tan\u0131mlanm\u0131\u015F ama\xe7, hedef ve g\xf6stergeler kapsam\u0131nda y\xf6nlendirilmesinin sa\u011Flanmas\u0131",
                "list": [
                    "Y\xf6netim Teorileri",
                    "Y\xf6netici ve Y\xf6neticilik Anlay\u0131\u015Flar\u0131",
                    "Bir \u015Eirketin Organizasyonel Kurgusunun \xd6mr\xfc ve Y\xf6netim \u015Eekilleri ile \u0130li\u015Fkisi",
                    "Y\xf6netim Anlay\u0131\u015Flar\u0131 ve Organizasyonel Davran\u0131\u015Flar",
                    "Hedeflerle Y\xf6netimin, \u015Eirket Stratejisi ve \u015Eirket K\xfclt\xfcr\xfcndeki Onemi",
                    "Hedef Belirleme S\xfcreci ve \u0130\u015Fleyi\u015Fi",
                    "Klasik Performans Y\xf6netimi",
                    "Hedefler, Beklentiler ve \xd6d\xfcller"
                ]
            },
            {
                "title": "\u0130leri Y\xf6netici Geli\u015Ftirme Program\u0131",
                "text": "\u015Eirket k\xfclt\xfcr\xfc ve stratejisini destekleyecek ideal bir y\xf6netim anlay\u0131\u015F\u0131n\u0131n geli\u015Ftirilmesi, bireylerin hedeflerinin kurumsal hedeflerle \xf6rt\xfc\u015Fmesi sa\u011Flanarak \u015Firketin performas\u0131n\u0131n art\u0131r\u0131lmas\u0131, y\xf6netimin stratejik boyutunun uygulanmas\u0131 ve ilkelerin \u015Firket d\xfczeyinde uyarlanmas\u0131 i\xe7in gerekli \u015Fartlar\u0131n sa\u011Flanmas\u0131",
                "list": [
                    "Klasik ve \xc7a\u011Fda\u015F Y\xf6netim ve Y\xf6neticilik Anlay\u0131\u015Flar\u0131n\u0131n Geli\u015Fimi",
                    "Bir \u015Eirketin Organizasyonel Yap\u0131s\u0131n\u0131n \xd6mr\xfc ve Y\xf6netim \u015Eekilleri \u0130le \u0130li\u015Fkisi",
                    "Y\xf6netim Anlay\u0131\u015F\u0131na Uygun Bir Performans Y\xf6netim Sistemi Kurgulama ve \u0130\u015Flerlik Kazand\u0131rma",
                    "Talimatlarla Y\xf6netim",
                    "Hedeflerle Y\xf6netim",
                    "De\u011Ferlerle Y\xf6netim",
                    "Y\xf6netim Anlay\u0131\u015F\u0131ndaki Yeni Paradigmalar\u0131n Y\xf6netime Etkileri",
                    "Yetki ve Sorumluluklar\u0131n Delegasyonu",
                    "\u0130nsiyatif Kullanma ve Karar Verme",
                    "Hedef Belirleme S\xfcreci ve \u0130\u015Fleyi\u015Fi",
                    "Beklenti ve \xd6d\xfcller",
                    "\u0130leti\u015Fim Kanallar\u0131n\u0131 Etkin Kullanma",
                    "Ekip \xc7al\u0131\u015Fmas\u0131 \u0130le Ki\u015Filer Aras\u0131 \u0130li\u015Fki Geli\u015Ftirme",
                    "\xc7a\u011Fda\u015F Motivasyon Teknikleri"
                ]
            },
            {
                "title": "\u0130\u015Fletmelerde Performans \xd6l\xe7\xfcm\xfc ve Denetimi",
                "text": "\u015Eirketin rekabet avantaj\u0131n\u0131 yakalayabilmesi i\xe7in rakipleri aras\u0131nda nerede oldu\u011Funu, ge\xe7mi\u015F performans\u0131 ile k\u0131yaslamas\u0131n\u0131, hedefleri ile bulundu\u011Fu nokta aras\u0131ndaki mesafeyi irdeleyebilmesini sa\u011Flamak",
                "list": [
                    "Verimlilik, \xdcretkenlik, Etkililik, Etkenlik Kavramlar\u0131",
                    "Performans Y\xf6netimi",
                    "Performans \xd6l\xe7\xfcm ve Denetim Sistemleri",
                    "Performans G\xf6stergeleri",
                    "Toplam Performans\u0131n \xd6l\xe7\xfclmesi",
                    "De\u011Fer M\xfchendisli\u011Fi",
                    "De\u011Fer Y\xf6netimi Kavram ve Teknikleri",
                    "De\u011Fer M\xfchendisli\u011Finin A\u015Famalar\u0131"
                ]
            },
            {
                "title": "Karar Verme ve Problem \xc7\xf6zme",
                "text": "y\xf6neticili\u011Fin temelini olu\u015Fturan unsurlardan olan karar verme ve problem \xe7\xf6zme becerisinin geli\u015Ftirilmesini sa\u011Flamak",
                "list": [
                    "\u0130\u015F Ya\u015Fam\u0131n\u0131n Kritik Anlar\u0131nda, Mevcut Problem ile Bilinmeyen \xc7\xf6z\xfcm Aras\u0131ndaki En Uygun Denklemi Kurmak",
                    "Kritik Anlarda Gerekli Ki\u015Fisel ve Kurumsal Riskleri Alabilecek Bir \u0130nisiyatif Geli\u015Ftirmek",
                    "\xc7\xf6z\xfcme Giden Yolda \u0130\xe7sel ve D\u0131\u015Fsal \u0130leti\u015Fimi En Y\xfcksek Motivasyon ve \xd6zg\xfcven Enerjisi ile Desteklemek",
                    "Problemin Tan\u0131m\u0131 ve Kime G\xf6re Problem Oldu\u011Funun Belirlenmesi",
                    "Sorun ve \xc7\xf6z\xfcm Denkleminin Sa\u011Flanmas\u0131",
                    "Karar Verme Ihtiyac\u0131 - Karar Verme Zevki ve Karar Verme Izd\u0131rab\u0131",
                    "\u0130\xe7sel ve D\u0131\u015Fsal \u0130leti\u015Fimimizin Duygu ve D\xfc\u015F\xfcncelerimize Etkisi",
                    "Karar An\u0131 ve En Uygun Karar\u0131 Vermek",
                    "Bireysel Stratejiler Geli\u015Ftirmek",
                    "Tak\u0131mda\u015Fl\u0131k Stratejileri Geli\u015Ftirmek",
                    "Bir I\u015Fi Ba\u015Faran Insanlar\u0131n Ba\u015Far\u0131s\u0131n\u0131n Modellenmesi",
                    "Paradigmalar, Riskler ve Bak\u0131\u015F A\xe7\u0131lar\u0131"
                ]
            },
            {
                "title": "Kurumsal Y\xf6neti\u015Fim",
                "text": "\u015Eirketlerin mali piyasalara entegrasyonu i\xe7in ka\xe7\u0131n\u0131lmaz olan kurumsal y\xf6neti\u015Fim ilkelerin tan\u0131t\u0131lmas\u0131 ve bu s\xfcre\xe7lerin uygulamal\u0131 olarak incelenmesini ama\xe7lamak",
                "list": [
                    "Kurumsal y\xf6neti\u015Fim ilkeleri",
                    "Kurumsal y\xf6neti\u015Fim uygulamalar\u0131",
                    "Kurumsal y\xf6neti\u015Fim uygulamalar\u0131n\u0131n \u015Firket ve finans piyasalar\u0131na katk\u0131lar\u0131",
                    "Stratejik y\xf6netim ve stratejik planlama",
                    "\u0130\u015F plan\u0131 gereksinimi, i\u015Fin tan\u0131mlanmas\u0131, \u015Firketin kendi kimli\u011Fini kazanmas\u0131",
                    "Rating s\xfcreci",
                    "Rating uygulamalar\u0131n\u0131n yat\u0131r\u0131mc\u0131ya, \u015Firketlere, ve genel ekonomiye katk\u0131lar\u0131"
                ]
            },
            {
                "title": "S.W.O.T. Analizi",
                "text": "\xc7evre analizinden hareketle kar\u015F\u0131la\u015F\u0131labilecek f\u0131rsatlar ve tehditler ele al\u0131n\u0131p ba\u015Far\u0131 fakt\xf6rleri analiz edilerek, bir firman\u0131n g\xfc\xe7l\xfc ve zay\u0131f y\xf6nleri tart\u0131\u015F\u0131lmas\u0131",
                "list": [
                    "Swot Analizinin Stratejik Planlamadaki Yeri",
                    "Temel Kavramlar",
                    "Organizasyonu Tan\u0131mlama",
                    "Rakipleri Belirleme",
                    "Kaynaklar\u0131 Belirleme",
                    "\xc7evre Tan\u0131mlanmas\u0131",
                    "\xc7evresel De\u011Fi\u015Fimleri, Trendleri, Olaylar\u0131 Tan\u0131ma",
                    "\xc7evresel De\u011Fi\u015Fimlerin, Trendlerin, Olaylar\u0131n Varl\u0131\u011F\u0131n\u0131 G\xf6sterme",
                    "\xc7evresel De\u011Fi\u015Fimlerin, Trendlerin, Olaylar\u0131n Etkisini Belirleme",
                    "Etkilerin Sonu\xe7lar\u0131n\u0131n Belirlenmesi ve De\u011Ferlendirilmesi",
                    "Yetkinlik Analizi",
                    "End\xfcstri Ba\u015Far\u0131 Fakt\xf6rlerini Belirleme",
                    "End\xfcstri Ba\u015Far\u0131 Fakt\xf6rlerini Firma A\xe7\u0131s\u0131ndan De\u011Ferlendirme",
                    "End\xfcstri Ba\u015Far\u0131 Fakt\xf6rlerini Rakipler ve End\xfcstri A\xe7\u0131s\u0131ndan De\u011Ferlendirme",
                    "Rekabet \xdcst\xfcnl\xfc\u011F\xfc, Ay\u0131r\u0131mc\u0131 \xdcst\xfcnl\xfck, End\xfcstri Standart\u0131, Zay\u0131fl\u0131k, Ana Zay\u0131fl\u0131k Y\xf6nlerinin Belirlenmesi",
                    "Swot Sonu\xe7lar\u0131n\u0131 Kullanma"
                ]
            },
            {
                "title": "Stratejik D\xfc\u015F\xfcnme, Stratejik Y\xf6netim",
                "text": "Stratejik y\xf6netim anlay\u0131\u015F\u0131n\u0131n yerle\u015Fmesi, stratejik d\xfc\u015F\xfcnme ve strateji geli\u015Ftirme konusunda y\xf6neticilerin ve proje ekiplerinin, stratejik planlama, proje y\xf6netimi ve ba\u015Far\u0131l\u0131 uygulamalar konusunda e\u011Fitilerek yetkinlik kazanmalar\u0131na destek vermek",
                "list": [
                    "Kurumsal Stratejik Planlama Projesinin Planlanmas\u0131 ve Yap\u0131land\u0131r\u0131lmas\u0131",
                    "Stratejik Plan Haz\u0131rlama S\xfcreci",
                    "Temel Y\xf6netsel De\u011Ferlerin G\xf6zden Ge\xe7irilmesi",
                    "Stratejik ve Uzun Vadeli Planlama Hedeflerinin Tan\u0131mlanmas\u0131",
                    "Ba\u015Far\u0131 Fakt\xf6rlerinin Tan\u0131mlanmas\u0131",
                    "Uygulama Stratejilerinin Tan\u0131mlanmas\u0131",
                    "Bo\u015F Alan Analizi",
                    "Kurumsal Stratejik Plan Haz\u0131rlama Faaliyetlerinin Tan\u0131mlanmas\u0131 ve Planlanmas\u0131",
                    "Stratejik Plan Haz\u0131rlama Projelerinin Y\xf6netimi",
                    "Kurumsal Stratejik Plan B\xfct\xfcnle\u015Ftirmesi",
                    "Kurumsal Stratejik Plan Tan\u0131t\u0131m ve Payla\u015F\u0131m\u0131"
                ]
            },
            {
                "title": "Stratejik Planlama",
                "text": "Bir \u015Firketin \xf6n\xfcm\xfczdeki y\u0131llarda nereye, ne \u015Fekilde gitmek istedi\u011Fini ve oraya ula\u015F\u0131p ula\u015Fmad\u0131\u011F\u0131n\u0131 nas\u0131l denetleyece\u011Fi belirlenip her \u015Firketin kendi k\xfclt\xfcr\xfc ve \xf6ncelikleri do\u011Frultusunda farkl\u0131 yakla\u015F\u0131mlar\u0131n irdelenmesi",
                "list": [
                    "Stratejik Planlamaya Ge\xe7i\u015F Haz\u0131rl\u0131\u011F\u0131",
                    "D\u0131\u015Fardan Dan\u0131\u015Fmanl\u0131k Hizmeti Alarak veya \u0130\xe7eriden Olu\u015Fturulacak Ekip \u0130le Yola \xc7\u0131kmak",
                    "\u0130lgili Birim ve Y\xf6netim Kademeleri ile Planlama",
                    "Plan\u0131n Uygulanabilirli\u011Fini G\xfcvenceye Almak",
                    "Stratejik Analiz",
                    "Swot Analizleri",
                    "Organizasyonel Zay\u0131f Nokta Analizleri",
                    "Stratejik Y\xf6nlendirme",
                    "Stratejik Hedeflendirme ve Metot Tespiti",
                    "Stratejik Senkronizasyon",
                    "Aksiyonel Planlama",
                    "\u015Eirket Stratejisinin Kaleme Al\u0131nmas\u0131, Hedeflendirilmesi, Atanmas\u0131",
                    "\u015Eirket Stratejisi Uygulama Plan\u0131n\u0131n \u0130zlenmesi ve Sapmalar\u0131n \xd6nlenerek Geli\u015Ftirilmesi",
                    "\u015Eirket Stratejisi Planlama S\xfcrecinin Performans Y\xf6netimi"
                ]
            },
            {
                "title": "\u015Eirket \u0130\xe7i \u0130leti\u015Fim ve Davran\u0131\u015F Geli\u015Ftirme",
                "text": "Kurum i\xe7i ili\u015Fkileri geli\u015Ftirmeyi, i\xe7 m\xfc\u015Fteri kavram\u0131n\u0131 herkese benimseterek, empatik bir anlay\u0131\u015Fla \xe7al\u0131\u015Fma bar\u0131\u015F\u0131 olu\u015Fturmay\u0131 hedeflemek, bu ama\xe7la kendini tan\u0131ma ile ba\u015Flayan ve di\u011Fer insanlarla olan ili\u015Fkileri tan\u0131mlamak ve geli\u015Ftirmek",
                "list": [
                    "Kurum i\xe7i \u0130leti\u015Fim",
                    "\u0130nsan \u0130li\u015Fkilerinde Kar\u015F\u0131la\u015F\u0131labilecek Engelleri \xc7\xf6z\xfcmleyebilecek Analizci Bir Bak\u0131\u015Fa Sahip Olmak",
                    "G\xfc\xe7l\xfc ve Zay\u0131f Y\xf6nlerimizin Fark\u0131nda Olmak",
                    "\u0130leti\u015Fime Etki Eden \xd6zelliklerimiz",
                    "Bask\u0131n Ki\u015Filik \xd6zelliklerimiz",
                    "Do\u011Fru Anlamak ve Anla\u015F\u0131lmak",
                    "Bireysel ve Kurumsal Uzla\u015Fma Stratejileri Geli\u015Ftirmek",
                    "\u015Eirket i\xe7i \xc7at\u0131\u015Fmalar\u0131 \xd6nlemenin Yollar\u0131n\u0131 Tan\u0131mlamak",
                    "Organizasyonel Davran\u0131\u015F Geli\u015Ftirme",
                    "Ki\u015Fisel Tav\u0131r, De\u011Fer ve Tutumlar\u0131n Analizi",
                    "Ki\u015Fileraras\u0131 Ama\xe7, Hedef ve De\u011Fer Yarg\u0131lar\u0131"
                ]
            },
            {
                "title": "\u015Eirket K\xfclt\xfcr\xfc Olu\u015Fturma",
                "text": "Kurumun vizyon ve misyonunu tan\u0131mlamak, \u015Firket k\xfclt\xfcr\xfcn\xfcn yeni y\xf6netsel yakla\u015F\u0131mdaki anlam\u0131n\u0131 kavramak ve \u015Firketin k\xfclt\xfcrel ge\xe7mi\u015Fi ve gelece\u011Fini birle\u015Ftirecek yap\u0131sal s\xfcreci t\xfcm a\u015Famalar\u0131 ile incelemek",
                "list": [
                    "K\xfclt\xfcr nedir? \u015Eirket K\xfclt\xfcr\xfc nedir?",
                    "\u015Eirketin K\xfclt\xfcr D\xfczeyleri",
                    "Alt K\xfclt\xfcrler, Yabanc\u0131 K\xfclt\xfcrler",
                    "\u015Eirket K\xfclt\xfcr\xfcn\xfcn Temel \xd6\u011Feleri",
                    "\u015Eirket K\xfclt\xfcr\xfcn\xfcn \xc7al\u0131\u015Fanlar \u0130\xe7in Anlam\u0131",
                    "\u015Eirket K\xfclt\xfcr\xfcn\xfcn Y\xf6netimi, Tasar\u0131m\u0131, Desteklenmesi ve De\u011Fi\u015Fim K\xfclt\xfcr\xfc",
                    "\u0130\u015F Ahlak\u0131 ve Organizasyonel K\xfclt\xfcr"
                ]
            },
            {
                "title": "Tak\u0131m Olu\u015Fturma",
                "text": "Ekip olma ve ekip \xe7al\u0131\u015Fmas\u0131 yapabilme s\xfcreci \xf6rneklerle tan\u0131t\u0131l\u0131p ve ekip \xe7al\u0131\u015Fmas\u0131nda ortaya \xe7\u0131kan sorunlar\u0131 analiz etmede kullan\u0131lacak y\xf6ntemler irdelenmesi ve etkin bir ekip y\xf6netimi i\xe7in davran\u0131\u015F geli\u015Ftirme \xfczerinde durulmas\u0131",
                "list": [
                    "Ekip Tan\u0131m\u0131",
                    "Ekip \xc7al\u0131\u015Fmas\u0131 Engelleri",
                    "Ekip \u0130\xe7i \u0130leti\u015Fim",
                    "Ba\u015Far\u0131l\u0131 Bir Ekip Olu\u015Fturman\u0131n Fakt\xf6rleri",
                    "Etkin Olan ve Olmayan Ekiplerin \xd6zellikleri",
                    "Ekip Olma S\xfcreci A\u015Famalar\u0131",
                    "Y\xfcksek Performansl\u0131 Bir Tak\u0131m Olu\u015Fturma",
                    "Ekip I\xe7i Yap\u0131c\u0131 ve Y\u0131k\u0131c\u0131 Davran\u0131\u015Flar\u0131n Tan\u0131mlanmas\u0131",
                    "Ba\u015Fkalar\u0131 \xdczerinde Etkili Olma",
                    "Liderlik Tarzlar\u0131",
                    "\xc7at\u0131\u015Fmalar\u0131 \xc7\xf6zmede Bir Yakla\u015F\u0131m",
                    "Ekipte \xdcye Rolleri"
                ]
            },
            {
                "title": "Temel Y\xf6netici Geli\u015Ftirme Program\u0131",
                "text": "Y\xf6netimin temelini olu\u015Fturan planlama ve i\u015Fleri organize etme, uygulama, kontrol ve y\xf6nlendirme becerilerinin geli\u015Ftirilmesi",
                "list": [
                    "Y\xf6netim, Y\xf6netici Tan\u0131m\u0131 ve Sorumluluklar\u0131",
                    "Y\xf6netimin Temel Fonksiyonlar\u0131",
                    "Planlama ve Organize Etme",
                    "Koordinasyon",
                    "Uygulama ve Kontrol",
                    "Y\xf6netimde Karar Verme \u0130\u015Flevi",
                    "\u0130leti\u015Fim S\xfcreci ve Engelleri",
                    "Tak\u0131m \xc7al\u0131\u015Fmas\u0131 ve Hedef Birli\u011Fi Olu\u015Fturma",
                    "Motivasyon Teknikleri"
                ]
            },
            {
                "title": "Y\xf6neticilikten Liderli\u011Fe Ge\xe7i\u015F",
                "text": "Kat\u0131l\u0131mc\u0131lar\u0131n liderlik hakk\u0131ndaki becerilerini geli\u015Ftirmek, y\xf6netiminde liderlik yakla\u015F\u0131mlar\u0131n\u0131n nas\u0131l kullan\u0131ld\u0131\u011F\u0131n\u0131 anlamak ve karar alma s\xfcre\xe7lerinde beceri sahibi olmay\u0131 ama\xe7lamak",
                "list": [
                    "\xc7a\u011Fda\u015F Y\xf6netim Yakla\u015F\u0131mlar\u0131 \u0130\xe7inde Liderlik",
                    "\xd6rg\xfct Y\xf6netimini Etkileyen Liderlik Yakla\u015F\u0131mlar\u0131",
                    "\xd6rg\xfct Y\xf6netiminde Liderlerin Sorumluluklar\u0131",
                    "Liderlik Yetkinliklerinin \xd6\u011Frenilmesi",
                    "Etkin Liderlik Ko\u015Fulu",
                    "Liderli\u011Fin \xd6rg\xfct K\xfclt\xfcr\xfcne Etkisi"
                ]
            }
        ]
    },
    {
        "title": "Y\xf6netim Sistemleri Programlar\u0131",
        "list": [
            {
                "title": "Alt\u0131 Sigma Yakla\u015F\u0131m\u0131",
                "text": "Alt\u0131 sigma yakla\u015F\u0131m\u0131 ve bu yakla\u015F\u0131m\u0131n uygulan\u0131\u015F\u0131, ana prosesleri ve m\xfc\u015Fterileri belirlemek, m\xfc\u015Fteri ihtiya\xe7lar\u0131n\u0131 tan\u0131mlamak, mevcut performans\u0131 \xf6l\xe7mek",
                "list": [
                    "Alt\u0131 Sigma Yakla\u015F\u0131m\u0131 ve \xd6nemi",
                    "Alt\u0131 Sigma Yakla\u015F\u0131m\u0131n\u0131n Uygulan\u0131\u015F\u0131",
                    "Ana Prosesleri ve M\xfc\u015Fterilerini Belirlemek",
                    "M\xfc\u015Fteri \u0130htiya\xe7lar\u0131n\u0131 Tan\u0131mlamak",
                    "Mevcut Performans\u0131 \xd6l\xe7mek",
                    "Alt\u0131 Sigma Prosesini Geli\u015Ftirme",
                    "Alt\u0131 Sigma Sistemini Uygulamak",
                    "Alt\u0131 Sigma Yakla\u015F\u0131m\u0131n\u0131 Hayata Ge\xe7irmek",
                    "Alt\u0131 Sigma \xc7al\u0131\u015Fmalar\u0131na Nerede Ve Nas\u0131l Ba\u015Flamal\u0131y\u0131z?",
                    "Alt\u0131 Sigma Organizasyonu \u0130\xe7in Rolleri Belirlemek",
                    "Organizasyonun Alt\u0131 Sigma \u0130\xe7in \xd6nemi",
                    "Alt\u0131 Sigma Uygulamas\u0131na \xd6rnekler"
                ]
            },
            {
                "title": "Benchmarking",
                "text": "\xdcr\xfcn / hizmet kalitesinin veya s\xfcre\xe7lerin iyile\u015Ftirilmesine y\xf6nelik olarak kullan\u0131lan tekniklerden birisi olan benchmarking hakk\u0131nda kat\u0131l\u0131mc\u0131lar\u0131n bilgilendirilmesi ve uygulamaya y\xf6nelik ad\u0131mlar\u0131n a\xe7\u0131klanmas\u0131",
                "list": [
                    "K\u0131yaslaman\u0131n Tan\u0131m\u0131",
                    "K\u0131yaslama \xc7e\u015Fitleri ve Modelleri",
                    "K\u0131yaslama Modelleri ve Engelleri",
                    "K\u0131yaslaman\u0131n D\xf6rt Ad\u0131m\u0131",
                    "Nas\u0131l K\u0131yaslamal\u0131y\u0131z, Kiminle K\u0131yaslamal\u0131y\u0131z?",
                    "K\u0131yaslamada Yap\u0131lan Hatalar",
                    "K\u0131yaslama ile Toplam Kaliteye Giden Yol",
                    "Uygulamalar ve \xd6rnekler ile Al\u0131\u015Ft\u0131rmalar"
                ]
            },
            {
                "title": "De\u011Fi\u015Fim M\xfchendisli\u011Fi",
                "text": "De\u011Fi\u015Fim m\xfchendisli\u011Finin farkl\u0131 yakla\u015F\u0131m\u0131, de\u011Fi\u015Fim m\xfchendisli\u011Fi teknikleri, de\u011Fi\u015Fim m\xfchendisli\u011Finde a\u015Famalar, de\u011Fi\u015Fim y\xf6netiminde izlenecek stratejinin, \u015Firket stratejisi do\u011Frultusunda ayarlanmas\u0131",
                "list": [
                    "De\u011Fi\u015Fim M\xfchendisli\u011Finin Farkl\u0131 Yakla\u015F\u0131m\u0131",
                    "S\xfcre\xe7 Odakl\u0131l\u0131k",
                    "\u0130\u015F S\xfcre\xe7leri",
                    "De\u011Fi\u015Fim M\xfchendisli\u011Fi Teknikleri",
                    "\u0130\u015F Basitle\u015Ftirme",
                    "Yeniden Yap\u0131lanma",
                    "D\xf6n\xfc\u015F\xfcm",
                    "De\u011Fi\u015Fim M\xfchendisli\u011Finde A\u015Famalar",
                    "S\xfcre\xe7 Y\xf6netimi",
                    "S\xfcre\xe7 Haritalar\u0131",
                    "S\xfcre\xe7 Performans\u0131",
                    "De\u011Fi\u015Fim Y\xf6netiminde \u0130zlenecek Stratejinin, \u015Eirket Stratejisi Do\u011Frultusunda Ayarlanmas\u0131",
                    "De\u011Fi\u015Fim M\xfchendisli\u011Finde; Proje Ekibi, Proje M\xfc\u015Fterisi, Hissedarlar ve di\u011Fer Rollerin tan\u0131mlanmas\u0131"
                ]
            },
            {
                "title": "Hata Modu ve Etki Analizi (FMEA)",
                "text": "FMEA \xe7al\u0131\u015Fmas\u0131n\u0131n amac\u0131 ve \xfcr\xfcn tan\u0131mlamas\u0131, proje ekibinin belirlenmesi, proses FMEA, tasar\u0131m FMEA, \xe7al\u0131\u015Fma sonu\xe7lar\u0131n\u0131n de\u011Ferlendirilmesi",
                "list": [
                    "FMEA \xc7al\u0131\u015Fmas\u0131n\u0131n Amac\u0131 ve \xdcr\xfcn Tan\u0131mlamas\u0131",
                    "Proje Ekibinin Belirlenmesi",
                    "Proses FMEA",
                    "Tasar\u0131m FMEA",
                    "FMEA \xc7al\u0131\u015Fma Sonu\xe7lar\u0131n\u0131n De\u011Ferlendirilmesi"
                ]
            },
            {
                "title": "Hizmet Kalitesini Geli\u015Ftirme Teknikleri",
                "text": "\xdcr\xfcnlerin ve hizmet kalitesinin iyile\u015Ftirilmesi ve bu yolla m\xfc\u015Fteri memnuniyetinin art\u0131r\u0131lmas\u0131nda yararlan\u0131labilecek tekniklerin uygulamaya d\xf6n\xfck olarak a\xe7\u0131klanmas\u0131",
                "list": [
                    "Toplam Kalite Anlay\u0131\u015F\u0131 ve S\xfcrekli \u0130yile\u015Ftirme",
                    "S\xfcrekli \u0130yile\u015Ftirme Teknikleri ve Kullan\u0131m Alanlar\u0131",
                    "Kalite \u2013 Verimlilik \u0130li\u015Fkisi",
                    "Beyin F\u0131rt\u0131nas\u0131 ve Veri Toplama Teknikleri",
                    "\u0130\u015F Ak\u0131\u015F Diyagramlar\u0131",
                    "De\u011Fi\u015Fkenlik ve Histogramlar",
                    "Normal Da\u011F\u0131l\u0131m ve Pareto Analizi",
                    "Neden-Sonu\xe7 Analizi",
                    "Kontrol \xc7izelgeleri ve \u0130li\u015Fki Diyagramlar\u0131",
                    "Fayda - Maliyet Analizi ve Kuvvet Alan Analizi"
                ]
            },
            {
                "title": "ISO 14001 \xc7evre Y\xf6netim Sistemi Bilin\xe7lendirme",
                "text": "Kat\u0131l\u0131mc\u0131lar\u0131n \xc7evre ve \xc7evre Y\xf6netimi, ISO 14001:1996 standard\u0131, standart gerekliliklerine g\xf6re \xc7YS\u2019nin kurulmas\u0131 ve s\xfcrd\xfcr\xfclmesi, \xe7evre ile ilgili yerel d\xfczenlemeler, ISO 14001\u2019in di\u011Fer y\xf6netim sistemleri ile uyumu hakk\u0131nda bilgi sahibi olmalar\u0131n\u0131 ama\xe7lamak",
                "list": [
                    "\xc7evre ve \xc7evre Y\xf6netimi Esaslar\u0131 ve Tan\u0131mlar",
                    "\xc7evre Mevzuat\u0131",
                    "\xc7evre Y\xf6netim Sistemi ISO 14001:1996",
                    "Ulusal, Yerel ve Uluslararas\u0131 D\xfczenlemeler, Y\xf6netmelikler",
                    "\xc7evre Unsurlar\u0131 ve \xc7evre Etkileri",
                    "\xc7evre Y\xf6netim Sisteminin olu\u015Fturulmas\u0131",
                    "Di\u011Fer Y\xf6netim Sistemleri ile Benzerlikler / Farkl\u0131l\u0131klar"
                ]
            },
            {
                "title": "ISO 14001 \xc7evre Y\xf6netim Sistemi \u0130\xe7 Denet\xe7i E\u011Fitimi",
                "text": "ISO 14001:1996 \xc7evre Y\xf6netim Sistemi standard\u0131n\u0131 yorumlayabilen, Kalite Y\xf6netim ve \xc7evre Y\xf6netim Sistemleri aras\u0131ndaki benzerlik / farkl\u0131l\u0131klar\u0131 anlam\u0131\u015F, Denetim gerekliliklerini kavram\u0131\u015F ve etkin bir \u015Fekilde denetim ger\xe7ekle\u015Ftirebilecek denet\xe7iler yeti\u015Ftirmek",
                "list": [
                    "\xc7evre Y\xf6netim Standard\u0131n\u0131n ve ISO 14001\u2019nin geli\u015Fimi",
                    "\xc7evre ve \xc7evre Y\xf6netim Sistemi Genel A\xe7\u0131klamalar\u0131",
                    "\xc7evre ve Kalite Y\xf6netim Sistemlerinin  Ba\u011Flant\u0131lar\u0131",
                    "ISO 14001 Denetim Teknikleri ve Uygulamalar\u0131",
                    "Denetimin Raporlanmas\u0131",
                    "Denetimin Takibi"
                ]
            },
            {
                "title": "ISO 9001:2000 Kalite Y\xf6netim Sistemi Bilin\xe7lendirme",
                "text": "Kalite bilincinin olu\u015Fturulmas\u0131 ve ortak dil birli\u011Finin sa\u011Flanmas\u0131, ISO 9000 ve Kalite G\xfcvence Sisteminin kurulmas\u0131 i\xe7in t\xfcm gerekliliklerin anlat\u0131lmas\u0131",
                "list": [
                    "Kalite Nedir? Kalite \u0130le \u0130lgili Temel Kavramlar",
                    "ISO 9000 Nedir?",
                    "ISO 9000\u2019in Tarihsel Geli\u015Fimi",
                    "Kalite G\xfcvence Sisteminin ve Belgelendirmenin Yarar\u0131",
                    "ISO 9000 Serisi Standartlar\u0131n Tan\u0131t\u0131m\u0131",
                    "ISO 9001 Standart Maddelerinin Kapsaml\u0131 A\xe7\u0131klamas\u0131"
                ]
            },
            {
                "title": "ISO 9001:2000 Kalite Y\xf6netim Sistemi \u0130\xe7 Denet\xe7i E\u011Fitimi",
                "text": "Kalite bilinci y\xfckselmi\u015F, ISO 9000 standard\u0131n\u0131 ve kalite y\xf6netim sistemini sistematik ve objektif olarak yorumlayarak geli\u015Fimine katk\u0131da bulunabilen, denetim konular\u0131nda gerekli bilgilerle donat\u0131lm\u0131\u015F, kurulu\u015F i\xe7inde etkin olarak denetim yapabilecek denet\xe7iler yeti\u015Ftirmek",
                "list": [
                    "Kalite Sistemleri ve Standartlar\u0131",
                    "Denetim Standartlar\u0131",
                    "Denetimin Tan\u0131m\u0131, Ama\xe7lar\u0131 ve Tipleri",
                    "Denet\xe7i \xd6zellikleri, G\xf6rev ve Sorumluluklar",
                    "Denetime Haz\u0131rl\u0131k ve Denetimin Ger\xe7ekle\u015Ftirilmesi",
                    "Denetimin Raporlanmas\u0131 ve Sonu\xe7lar\u0131n \u0130zlenmesi"
                ]
            },
            {
                "title": "\u0130statistiki Analiz ve Karar Verme",
                "text": "Kalite geli\u015Ftirme faliyetlerinin temelini olu\u015Fturan istatistiki analiz y\xf6ntemlerini \xf6\u011Fretmek ve karar verme teknikleri hakk\u0131nda uygulama \xf6rnekleriyle birlikte bilgi vermek",
                "list": [
                    "\u0130statistiki Analiz ve Karar Verme Teknikleri",
                    "\xc7etele Tablosu ve Histogram",
                    "Pareto Analizi",
                    "Neden \u2013 Sonu\xe7 Analizi (Bal\u0131k K\u0131l\xe7\u0131\u011F\u0131 Diyagram\u0131)",
                    "Tak\u0131m \xc7al\u0131\u015Fmas\u0131 ve Beyin F\u0131rt\u0131nas\u0131",
                    "Da\u011F\u0131l\u0131m ve Korelasyon",
                    "Grupland\u0131rma",
                    "7 Ad\u0131mda Problem \xc7\xf6zme"
                ]
            },
            {
                "title": "\u0130\u015F Et\xfcd\xfc",
                "text": "Kat\u0131l\u0131mc\u0131lara i\u015Fletmelerde planlama, maliyetlendirme, \xfccretlendirme ve i\u015F d\xfczenleme i\xe7in gerekli olan zaman verilerinin belirlenmesi, \xe7al\u0131\u015Fma ko\u015Fullar\u0131n\u0131n iyile\u015Ftirilmesi, i\u015F basitle\u015Ftirme, ak\u0131\u015F d\xfczenleme konular\u0131nda verimlili\u011Fi art\u0131r\u0131c\u0131 teknikleri \xf6\u011Fretmek",
                "list": [
                    "S\xfcre\xe7 Tan\u0131m\u0131 ve \u0130\u015F Ak\u0131\u015F Analizi",
                    "Sentez (Sipari\u015F S\xfcrelerinin Belirlenmesi)",
                    "S\xfcre\xe7 Performanslar\u0131n\u0131n De\u011Ferlendirilmesi",
                    "Tempo Belirleme (Video Kaset G\xf6sterimi)",
                    "Zaman \xd6l\xe7me Y\xf6ntemi (Uygulamal\u0131)",
                    "Verilerin \u0130statistiksel De\u011Ferlendirmesi",
                    "Kay\u0131p Zaman Analizi ve Ek Paylar\u0131n Belirlenmesi",
                    "Standart Zamanlar\u0131n Hesaplanmas\u0131",
                    "S\xfcre\xe7 \u0130yile\u015Ftirme ve \u0130\u015F Basitle\u015Ftirme"
                ]
            },
            {
                "title": "Kaliteli Bir \u0130\u015F \xc7evresinin Yarat\u0131lmas\u0131",
                "text": "Kaliteli bir i\u015F \xe7evresinin olu\u015Fturulmas\u0131nda etken olan insan, proses ve teknoloji gibi temel dinamiklerin \xf6nemi ve kaliteli i\u015F \xe7evresinin sa\u011Flanmas\u0131ndaki rol\xfc ile bu temel dinamiklerin birbiriyle etkile\u015Fimlerinin ortaya konulmas\u0131",
                "list": [
                    "Kalitede \u0130nsan Fakt\xf6r\xfc",
                    "Proses Yakla\u015F\u0131m\u0131 ve Proses Kalitesi",
                    "Teknolojik Altyap\u0131 ve \xc7al\u0131\u015Fma Ortam\u0131 Kalitesi",
                    "\u0130nsan, Proses ve  Teknolojinin Birbiriyle Etkile\u015Fimleri",
                    "Dengeleme Yakla\u015F\u0131m\u0131",
                    "Kaliteli Bir I\u015F \xc7evresinin Olu\u015Fturulmas\u0131nda \u0130kicil Unsurlar",
                    "Kaliteli \u0130\u015F \xc7evresinin Y\xf6netimi"
                ]
            },
            {
                "title": "Kritik Kontrol Noktalar\u0131nda Risk Analizi (HACCP)",
                "text": "G\u0131da hijyeni konusunda bilgi sahibi olan, g\u0131dalar ile ilgili tehlikeleri yorumlayabilen, g\u0131da \xfcretimi ve servisi a\u015Famalar\u0131nda kritik kontrol noktalar\u0131 tespit edebilecek, al\u0131nmas\u0131 gereken \xf6nlemleri belirleyebilen ve HACCP Sistemini olu\u015Fturabilecek sorumlular\u0131n ve uygulayacak \xe7al\u0131\u015Fanlar\u0131n yeti\u015Ftirilmesi",
                "list": [
                    "HACCP Sistemi Tarih\xe7e ve Tan\u0131mlar",
                    "\xdcr\xfcn Tan\u0131mlamas\u0131 ve Ak\u0131\u015F Diyagramlar\u0131",
                    "Tehlike Analizi ve Kontrol Tedbirleri",
                    "Kritik Kontrol Noktalar\u0131n\u0131n Tespiti ve  Kritik Limitler",
                    "\u0130zleme Y\xf6ntemleri ve D\xfczeltici Faaliyetler",
                    "Tehlikeler (Mikrobiyolojik, Kimyasal, Fiziksel)",
                    "\xd6n Yeterlilik Program\u0131 (Hijyen Sistemi)",
                    "HACCP Sisteminin ISO 9000 Sistemi ile Entegrasyonu",
                    "Genel Plan \xd6rnekleri ve Pratik \xc7al\u0131\u015Fma"
                ]
            },
            {
                "title": "OHSAS 18001 \u0130\u015F Sa\u011Fl\u0131\u011F\u0131 ve G\xfcvenli\u011Fi \u0130\xe7 Denet\xe7i E\u011Fitimi",
                "text": "OHSAS 18001 \u0130\u015F Sa\u011Fl\u0131\u011F\u0131 ve G\xfcvenli\u011Fi Y\xf6netim Sistemi gerekliliklerine uygun denetim yapabilecek, OHSAS 18001 maddelerini yorumlayabilen, denetim gerekliliklerini kavram\u0131\u015F ve etkin bir \u015Fekilde denetim ger\xe7ekle\u015Ftirebilecek denet\xe7iler yeti\u015Ftirmek",
                "list": [
                    "OHSAS 18001 Y\xf6netim Sisteminin Geli\u015Fimi ve Tan\u0131mlar",
                    "\u0130\u015F Sa\u011Fl\u0131\u011F\u0131 ve G\xfcvenli\u011Fi Sisteminde Kullan\u0131lan Terminoloji",
                    "Ulusal ve Uluslararas\u0131 Y\xf6netmeliklerin Tan\u0131m\u0131",
                    "OHSAS 18001 Maddeleri",
                    "Denetim Gereklilikleri",
                    "Denetimin Y\xf6netimi, Raporlanmas\u0131 ve Takibi"
                ]
            },
            {
                "title": "OHSAS 18001 \u0130\u015F Sa\u011Fl\u0131\u011F\u0131 ve G\xfcvenli\u011Fi Y\xf6netim Sistemi Bilin\xe7lendirme",
                "text": "Kat\u0131l\u0131mc\u0131lar\u0131 OHSAS 18001 \u0130\u015F Sa\u011Fl\u0131\u011F\u0131 ve G\xfcvenli\u011Fi Y\xf6netim Sisteminin y\xfcr\xfct\xfclmesi ile ilgili sistem \u015Fartlar\u0131n\u0131n ve mevzuat\u0131n tan\u0131t\u0131m\u0131, sistem ve sistemin kurulmas\u0131 konusunda bilin\xe7lendirmek",
                "list": [
                    "\u0130\u015F Sa\u011Fl\u0131\u011F\u0131 ve G\xfcvenli\u011Fi Kavramlar\u0131",
                    "Uluslararas\u0131 \u0130SG Uygulamalar\u0131",
                    "OHSAS 18001 Y\xf6netim Maddeleri",
                    "Risk De\u011Ferlendirme Kavram\u0131na Genel Bak\u0131\u015F",
                    "Risk De\u011Ferlendirme Grup \xc7al\u0131\u015Fmas\u0131"
                ]
            },
            {
                "title": "Problem \xc7\xf6zme Teknikleri",
                "text": "\xc7al\u0131\u015Fanlara bir ekip ruhu i\xe7inde i\u015Fletmelerinde kar\u015F\u0131la\u015Facaklar\u0131 problemleri \xe7\xf6zmek i\xe7in kullanacaklar\u0131 y\xf6ntem ve metodlar\u0131 tan\u0131tmak ve onlar\u0131 uygulamal\u0131 olarak etkin kalite geli\u015Ftirme ara\xe7lar\u0131n\u0131 kullanabilir hale getirmek",
                "list": [
                    "Ekip Kurma",
                    "Toplant\u0131 Esaslar\u0131",
                    "Beyin F\u0131rt\u0131nas\u0131",
                    "Veri Toplama",
                    "Grupland\u0131rma",
                    "Da\u011F\u0131l\u0131m Diyagramlar\u0131",
                    "Histogram",
                    "Pareto \u015Eemas\u0131",
                    "Neden-Sonu\xe7 (Ishikawa) Diyagram\u0131",
                    "Problem Analizi (8-D Report)",
                    "D\xfczeltici Aksiyon"
                ]
            },
            {
                "title": "Sat\u0131n Alma ve Tedarik\xe7i De\u011Ferlendirme",
                "text": "Sat\u0131n alma tekniklerinin ve tedarik\xe7i de\u011Ferlendirmenin detaylar\u0131, sat\u0131n alma y\xf6netimi de\u011Ferlendirmesi",
                "list": [
                    "Sat\u0131n Alma ve Kar; Kar \xc7arpan\u0131",
                    "Sat\u0131n Alman\u0131n Be\u015F Temel Do\u011Frusu (Zaman, Fiyat, Miktar, Kalite, Kaynak)",
                    "Sat\u0131n Alma Bi\xe7imleri (Do\u011Frudan Sat\u0131nalma, Leasing Kiralama)",
                    "Sat\u0131n Almada De\u011Fer Analizi \u0130\xe7in 10 Temel Soru",
                    "Stok Kontrolde ABC Y\xf6ntemi",
                    "A/B/C S\u0131n\u0131flamas\u0131ndaki Stok Kalemlerinin Servis \xd6zellikleri",
                    "Stok Kontrolde Ekonomik Sipari\u015F Miktar\u0131 Modeli",
                    "Stok Kontrolde \xc7e\u015Fitli Sipari\u015F Miktarlar\u0131 ve Ortalama",
                    "Envanter D\xfczeyleri",
                    "S\xfcrekli G\xf6zden Ge\xe7irme Politikas\u0131 \u0130\xe7in Yeniden Sipari\u015F Noktas\u0131",
                    "Periyodik G\xf6zden Ge\xe7irme Politikas\u0131 \u0130\xe7in Yeniden Sipari\u015F Noktas\u0131",
                    "Tedarik\xe7i Performans\u0131n\u0131n De\u011Ferlendirilmesi",
                    "Sat\u0131n Alma Y\xf6netimi De\u011Ferlendirmesi",
                    "Kalite Sistem Diyagram\u0131",
                    "Sat\u0131n Alma \u0130stek Formu",
                    "Sipari\u015F Emri ve Sat\u0131n Almada Di\u011Fer Formlar",
                    "Uluslararas\u0131 Sat\u0131n Alma",
                    "Kurlardaki De\u011Fi\u015Fmelerin Sat\u0131n Alma \xdczerindeki Etkisi"
                ]
            },
            {
                "title": "Sipari\u015F ve Stok Y\xf6netimi",
                "text": "\xdcretim sistemlerinde stok kavram\u0131n\u0131 a\xe7\u0131klamak, tedarik, sevkiyat, depolama ve stok y\xf6netimine ili\u015Fkin temel kavramlar\u0131 aktarmak",
                "list": [
                    "\xdcretim Sistemlerinde Stok Kavram\u0131",
                    "Stoklar\u0131n S\u0131n\u0131fland\u0131r\u0131lmas\u0131 ve \u0130\u015Fletme Ekonomisindeki \xd6nemi",
                    "Stok Kontrol\xfcn\xfcn Organizasyondaki Yeri",
                    "Stok Kontrol\xfcnden Etkilenen Maliyet Unsurlar\u0131",
                    "Tedarik, Sevkiyat ve Depolama",
                    "Stok Kay\u0131tlar\u0131 ve Stok Kontrol Y\xf6ntemleri",
                    "Belirsizlik Halinde Stok Kontrol\xfc",
                    "Stok Kontrol\xfcnde Bili\u015Fim Teknolojileri"
                ]
            },
            {
                "title": "S\xfcre\xe7 Y\xf6netimi ve \u0130yile\u015Ftirme",
                "text": "S\xfcre\xe7 yakla\u015F\u0131m\u0131n\u0131n \u015Firket \xe7al\u0131\u015Fanlar\u0131 taraf\u0131ndan \xf6z\xfcmsenmesinin uzun soluklu \xe7al\u0131\u015Fmalar\u0131n temelini olu\u015Fturaca\u011F\u0131 anlay\u0131\u015F\u0131n\u0131n aktar\u0131lmas\u0131",
                "list": [
                    "S\xfcre\xe7 Tan\u0131m\u0131",
                    "S\xfcre\xe7 Y\xf6netiminin Gereklili\u011Finin A\xe7\u0131klanmas\u0131",
                    "S\xfcre\xe7lerin Belirlenmesi",
                    "S\xfcre\xe7 \xd6zellikleri",
                    "S\xfcre\xe7lerin S\u0131n\u0131fland\u0131r\u0131lmas\u0131",
                    "S\xfcrecin Temel Unsurlar\u0131",
                    "S\xfcre\xe7 Hiyerar\u015Fisi",
                    "S\xfcre\xe7lerin Performans G\xf6stergelerinin Belirlenmesi",
                    "S\xfcre\xe7 Performanslar\u0131n\u0131n \u0130zlenmesi",
                    "Ak\u0131\u015F Diyagramlar\u0131",
                    "Kurulu\u015F Ama\xe7 ve Hedefleri ile S\xfcre\xe7 Performans G\xf6stergelerinin \u0130li\u015Fkilendirilmesi",
                    "Kritik S\xfcre\xe7lerin Belirlenmesi",
                    "S\xfcre\xe7 Analizi ve Geli\u015Ftirme Y\xf6ntemi"
                ]
            },
            {
                "title": "Tam Zaman\u0131nda \xdcretim",
                "text": "Tam Zaman\u0131nda \xdcretim felsefesi, ama\xe7lar\u0131, elemanlar\u0131 ve t\xfcm detaylar\u0131, \xfcretim s\xfcre\xe7lerinin iyile\u015Ftirilmesi",
                "list": [
                    "Tam Zaman\u0131nda \xdcretim Felsefesi",
                    "Tam Zaman\u0131nda \xdcretim Sistemlerinin Ama\xe7lar\u0131",
                    "Tam Zaman\u0131nda \xdcretim Sistemlerinin Elemanlar\u0131",
                    "\xdcretim S\xfcre\xe7lerinin \u0130yile\u015Ftirilmesi",
                    "Genel S\xfcre\xe7 Y\xf6netimi Kavram\u0131",
                    "S\xfcre\xe7 Analizi",
                    "S\xfcre\xe7 Geli\u015Ftirme"
                ]
            },
            {
                "title": "Tedarik\xe7i Y\xf6netimi",
                "text": "Tedarik edilen malzeme ve hizmetler baz\u0131nda kritiklik de\u011Ferlendirmesi, tedarik\xe7i se\xe7imi ve yeterlilik bak\u0131m\u0131ndan de\u011Ferlendirilmesi ile tedarik\xe7i performans kriterlerinin tamamlanmas\u0131 ve \xf6l\xe7\xfcmlenmesi",
                "list": [
                    "Tedarik Zinciri Y\xf6netimi",
                    "Simulat\xf6r ile Gruplara Oyun Oynatma",
                    "Temel Lojistik Faaliyetleri, Destek Faaliyetler",
                    "Strateji ve Planlama",
                    "\xdcretim ile Ilgili Startejiler ve \xdcretim \xc7izelgesi Olu\u015Fturulmas\u0131",
                    "\xdcr\xfcn Tahsisi",
                    "Depolama ve Stok Y\xf6netimi",
                    "M\xfc\u015Fteri Hizmet D\xfczeyi",
                    "Ula\u015F\u0131m, Ula\u015Ft\u0131rma T\xfcr\xfc Se\xe7imi ve Yer Se\xe7imi"
                ]
            },
            {
                "title": "Temel Kalite Y\xf6netimi",
                "text": "\xdcst ve orta kademe y\xf6neticileri Toplam Kalite, Kalitenin Temel \u0130lkeleri \xfczerine bilgilendirmek ve firman\u0131n bu do\u011Frultuda \xf6rg\xfctlenmesinin gereklili\u011Fini vurgulamak",
                "list": [
                    "Stratejik Planlama",
                    "Rekabet \xdcst\xfcnl\xfc\u011F\xfc",
                    "M\xfc\u015Fteri Tatmini",
                    "S\u0131f\u0131r Hata",
                    "Firma K\xfclt\xfcr\xfc",
                    "De\u011Fi\u015Fim",
                    "S\xfcrekli Geli\u015Fim",
                    "Tak\u0131m Oyunu"
                ]
            },
            {
                "title": "Temizlik ve D\xfczen (5S)",
                "text": "Temizlik ve D\xfczenin hayat\u0131m\u0131zdaki \xf6nemini kavramak, standartla\u015Ft\u0131rmak, i\u015F ve sosyal ya\u015Fant\u0131m\u0131za uygulamak, 5S y\xf6nteminin ne oldu\u011Funu, nas\u0131l uygulanmas\u0131 gerekti\u011Fini belirlemek",
                "list": [
                    "Temizlik Nedir?",
                    "Bizlere D\xfc\u015Fen G\xf6rev ve Sorumluluklar",
                    "5S Y\xf6netimi",
                    "(SEIRI) S\u0131n\u0131fland\u0131rma",
                    "(SEITON) D\xfczenleme",
                    "(SEISO) Temizlik",
                    "(SEIKETSU) Standartla\u015Ft\u0131rma",
                    "(SHITSUKE) Disiplin"
                ]
            },
            {
                "title": "Toplam \xdcretken Bak\u0131m",
                "text": "\u0130statistiki y\xf6ntemlerin kullan\u0131larak ar\u0131za nedenlerinin analiz edilmesi, ar\u0131za ve bak\u0131m oranlar\u0131n\u0131n ve maliyetlerinin d\xfc\u015F\xfcr\xfclmesi ve verimlili\u011Fin art\u0131r\u0131lmas\u0131",
                "list": [
                    "TPM yakla\u015F\u0131m\u0131 nedir? Nas\u0131l Kullan\u0131l\u0131r?",
                    "Hata Aysbergi",
                    "\xdcretimde 6 Kay\u0131p ve M\xfccadele Yollar\u0131",
                    "Bak\u0131mda M\xfc\u015Fteri Odakl\u0131l\u0131k",
                    "Bak\u0131mda Yetki Payla\u015F\u0131m\u0131",
                    "Just In Time (JIT) Tam Zaman\u0131nda - TPM ili\u015Fkisi",
                    "TPM\u2019de G\xf6revler ve \u0130leti\u015Fim",
                    "Temizlik Muayenedir!",
                    "OEE (Toplam Ekipman Etkinli\u011Fi) Hesab\u0131 ve Kullan\u0131lmas\u0131",
                    "TPM Kurulum A\u015Famalar\u0131"
                ]
            },
            {
                "title": "\xdcretim Planlama ve Stok Kontrol Teknikleri",
                "text": "K\u0131sa s\xfcrede teslimat\u0131 m\xfcmk\xfcn olan en d\xfc\u015F\xfck maliyet ile, esnek \xfcretimden fedakarl\u0131k etmeden ger\xe7ekle\u015Ftirmenin yollar\u0131",
                "list": [
                    "\xdcretim Sistemlerinde Kullan\u0131lan Kavramlar ve Yakla\u015F\u0131mlar",
                    "\u015Eirket Rek\xe2bet G\xfcc\xfcn\xfc Artt\u0131rmada \xdcretim-Stok Stratejileri",
                    "\xdcretim, \xdcretim Sistemleri ve Verimlilik",
                    "Yal\u0131n \xdcretim, \u0130sraflar ve 5S",
                    "Talep Tahminleri ve Ana \xdcretim \xc7izelgesi Olu\u015Fturma",
                    "Malzeme \u0130htiya\xe7 Planlamas\u0131 Tabanl\u0131 \xdcretim Planlamas\u0131",
                    "H\xfccresel \xdcretim ve Y\xf6netim",
                    "Haz\u0131rl\u0131k S\xfcrelerinin Analizi ve D\xfc\u015F\xfcr\xfclmesi",
                    "Stok Kontrol Parametrelerinin Elde Edilmesi ve Uygulanmas\u0131",
                    "\u0130tme ve \xc7ekme Sistemleri",
                    "Sonlu Kapasite \xc7izelgesi Olu\u015Fturma",
                    "Periyodik Parti Kontrol\xfc",
                    "G\xf6rsel \xdcretim Kontrol\xfc",
                    "\xdcretim S\xfcre\xe7lerinin \u0130yile\u015Ftirilmesi ve Dengeleme S\xfcreci",
                    "Tedarik\xe7i Programlar\u0131n\u0131 Kurma ve Geli\u015Ftirme",
                    "Faaliyet Tabanl\u0131 Maliyetlendirme"
                ]
            },
            {
                "title": "\xdcretim Sistemlerinde Yeni Yakla\u015F\u0131mlar",
                "text": "G\xfcn\xfcm\xfczdeki rekabet \u015Fartlar\u0131n\u0131 sa\u011Flamak i\xe7in m\xfc\u015Fteri istekleri do\u011Frultusunda ortaya \xe7\u0131kan modern \xfcretim sistemlerine ait felsefeleri, prensipleri ve uygulamalar\u0131 klasik \xfcretim sistemleri ile kar\u015F\u0131la\u015Ft\u0131rarak a\xe7\u0131klamak",
                "list": [
                    "Grup Teknolojisi",
                    "H\xfccresel \xdcretim Sistemi",
                    "TZ\xdc / Yal\u0131n \xdcretim / Y\xf6netim",
                    "H\u0131zl\u0131 Tepkisel \xdcretim",
                    "\xc7evik \xdcretim"
                ]
            },
            {
                "title": "\xdcr\xfcn Geli\u015Ftirme",
                "text": "\xdcr\xfcn geli\u015Ftirme s\xfcrecindeki olgular\u0131, pazar ve kullan\u0131c\u0131 istekleri, hata modu ve etkileri analiz etmek",
                "list": [
                    "\xdcr\xfcn Geli\u015Ftirme S\xfcreci",
                    "S\u0131ral\u0131 M\xfchendislik",
                    "E\u015F Zamanl\u0131 M\xfchendislik",
                    "Pazar ve Kullan\u0131c\u0131 \u0130steklerinin Belirlenmesi",
                    "\xdcr\xfcn Tasar\u0131m \xd6zellikleri",
                    "Kavramsal Tasar\u0131m",
                    "Ayr\u0131nt\u0131l\u0131 Tasar\u0131m",
                    "Kalite Fonksiyon A\xe7\u0131l\u0131m\u0131",
                    "Deney Tasar\u0131m\u0131",
                    "Hata Modu ve Etkileri Analizi",
                    "De\u011Fer Analizi"
                ]
            },
            {
                "title": "Verimlilik \xd6l\xe7me ve De\u011Ferlendirme",
                "text": "Verimlili\u011Fin \xf6nemi ve verimlilik bilincinin, verimlilik-\xfcretkenlik ili\u015Fkisinin, verimsizlik d\xf6ng\xfcs\xfcn\xfcn, verimlilik \xf6l\xe7\xfcm\xfcn\xfcn analizi, de\u011Ferlendirilmesi ve art\u0131r\u0131lmas\u0131 a\u015Famalar\u0131n\u0131 i\xe7eren verimlilik y\xf6netim sisteminin a\xe7\u0131klanmas\u0131",
                "list": [
                    "Verimlilik ve \xdcretkenlik Kavramlar\u0131 ve \xd6nemleri, Verimlilik ile \u0130lgili Di\u011Fer Kavramlar",
                    "Verimlilik ve \xdcretkenlik Bilinci Olu\u015Fturulmas\u0131n\u0131n \xd6nemi",
                    "Verimlilik Y\xf6netim Sistemi; Verimlili\u011Fin \xd6l\xe7\xfclmesi, De\u011Ferlendirilmesi ve Geli\u015Ftirilmesi",
                    "Verimlilik \xd6l\xe7me Ama\xe7lar\u0131",
                    "Verimlilik \xd6l\xe7\xfcm\xfcndeki Genel Yap\u0131",
                    "Verimlilik \xd6l\xe7\xfcm\xfcndeki Temel Ad\u0131mlar",
                    "Verimlilik Oranlar\u0131 ve \xd6zellikleri",
                    "Mali Verimlilik Oranlar\u0131",
                    "Verimlilik Oranlar\u0131n\u0131n S\u0131n\u0131fland\u0131r\u0131lmas\u0131",
                    "Verimlilik Oranlar\u0131nda Kullan\u0131lan Kavramlar",
                    "Verimlilik Analizi ve De\u011Ferlendirme",
                    "Verimlilik De\u011Ferlendirmede Kullan\u0131lan Oranlar"
                ]
            }
        ]
    }
];


const $d577306550767816$var$id = document.getElementById.bind(document);
const $d577306550767816$var$params = new URLSearchParams(location.search);
const $d577306550767816$var$q = parseInt($d577306550767816$var$params.get('q'));
const $d577306550767816$var$r = parseInt($d577306550767816$var$params.get('r'));
const $d577306550767816$var$page = !isNaN($d577306550767816$var$q) && !isNaN($d577306550767816$var$r);
$d577306550767816$var$id('app').appendChild($d577306550767816$var$page ? (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.section', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.container', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.columns', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.column', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.content.is-family-secondary', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('h1', (0, (/*@__PURE__*/$parcel$interopDefault($aecf0f9332b42428$exports)))[$d577306550767816$var$q].list[$d577306550767816$var$r].title), (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('p', (0, (/*@__PURE__*/$parcel$interopDefault($aecf0f9332b42428$exports)))[$d577306550767816$var$q].list[$d577306550767816$var$r].text), (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('ul', (0, (/*@__PURE__*/$parcel$interopDefault($aecf0f9332b42428$exports)))[$d577306550767816$var$q].list[$d577306550767816$var$r].list.map((value)=>(0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('li', value))))), (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.column#form-parent')))) : (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('div', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.section', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.container', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.title.has-text-centered', "E\u011Fitimler"))), (0, (/*@__PURE__*/$parcel$interopDefault($aecf0f9332b42428$exports))).map((value, indexQ)=>(0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.section', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.container', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.title.is-4', value.title), (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.columns.is-multiline', value.list.map((value, indexR)=>(0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.column.is-one-third.is-flex', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('a.box.is-family-secondary', {
            href: `?q=${indexQ}&r=${indexR}&z=${value.title}`
        }, (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.title.is-5', value.title), (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.subtitle.is-6', value.text.split(/^(.{100}\S*)/)[1] + '\u2026'))))))))));
if ($d577306550767816$var$page) {
    $d577306550767816$var$id('form-parent').appendChild($d577306550767816$var$id('form'));
    $d577306550767816$var$id('form').classList.remove('is-hidden');
    $d577306550767816$var$id('request').value = (0, (/*@__PURE__*/$parcel$interopDefault($aecf0f9332b42428$exports)))[$d577306550767816$var$q].list[$d577306550767816$var$r].title;
}

})();
//# sourceMappingURL=egitim.js.map
